const messages = {
  pt: {
    translations: {
      ticketChipRail: {
        moreOne: "Mais 1 tag",
        moreMany: "Mais {{count}} tags",
        kanbanStep: "Etapa Kanban",
        noQueue: "Sem fila",
        group: "Grupo",
        groupMember: "{{count}} membro",
        groupMember_plural: "{{count}} membros",
        groupTooltip: "Grupo de WhatsApp",
        groupShared: "Grupo compartilhado entre {{count}} conexões",
        tabTooltip: "Aba: {{name}}",
      },
      ticketRowActions: {
        menu: "Ações do atendimento",
        transfer: "Transferir",
        close: "Fechar atendimento",
        ignore: "Ignorar",
        reopen: "Reabrir",
        mute: "Silenciar grupo",
        unmute: "Reativar notificações do grupo",
        muted: "Grupo silenciado",
      },
      crossConnection: {
        chipPrefix: "Em atendimento",
        days7: "7 dias",
        connectionsCount: "{{count}} conexões",
        unknownAttendant: "Outro atendente",
        unknownConnection: "outra conexão",
        isServingOn: "está atendendo este cliente na conexão",
        since: "desde",
        modalTitle: "Cliente já em atendimento",
        modalHint: "Confira antes de responder para não duplicar o pedido.",
        acceptAnyway: "Aceitar mesmo assim",
        openOther: "Abrir atendimento de",
        viewOther: "Ver atendimento",
        cancel: "Cancelar",
        notifyCalledAlsoOn: "chamou também na conexão",
        notifyFallbackContact: "Seu cliente",
        bannerTitle: "Cliente em atendimento em outra conexão",
        onConnection: "na conexão",
        startedAt: "desde",
        chipAria: "Cliente em atendimento em outra conexão",
        lastClosedChip: "Atendido",
        lastClosedTitle: "Último atendimento em outra conexão",
        closedWord: "encerrado",
        agoMinutes: "há {{count}} min",
        agoHours: "há {{count}} h",
        agoDays: "há {{count}} dias",
        agoOneDay: "há 1 dia",
        agoNow: "agora",
        reasonLabel: "Motivo",
        demandLabel: "Tipo",
        showMore: "ver mais",
        showLess: "ver menos",
      },
      signup: {
        title: "Cadastre-se",
        subtitle: "Crie sua conta para começar a usar nossa plataforma",
        welcomeTitle: "Bem-vindo ao {{appName}}",
        welcomeMessage:
          "Crie sua conta e comece a gerenciar seus atendimentos de forma eficiente.",
        toasts: {
          success: "Usuário criado com sucesso! Faça seu login!!!.",
          fail: "Erro ao criar usuário. Verifique os dados informados.",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
          company: "Nome da Organização",
          phone: "Whatsapp (DDD + NÚMERO)",
        },
        buttons: {
          submit: "Cadastrar",
          submitting: "Cadastrando...",
          login: "Já tem uma conta? Entre!",
        },
        validation: {
          nameRequired: "O nome deve ter pelo menos 2 caracteres",
          companyRequired: "O nome da empresa deve ter pelo menos 2 caracteres",
          emailInvalid: "Digite um email válido",
          passwordTooShort: "A senha deve ter pelo menos 5 caracteres",
          phoneRequired: "O telefone é obrigatório",
          planRequired: "Selecione um plano",
        },
      },
      login: {
        title: "Login",
        welcomeTitle: "Bem-vindo ao {{appName}}",
        welcomeMessage:
          "Um novo dia chegou. É o seu dia para moldar. Faça login e comece a trabalhar em seus projetos.",
        form: {
          email: "Email",
          password: "Senha",
          button: "Acesse sua conta para continuar",
        },
        buttons: {
          submit: "Entrar",
          noAccount: "Não tem uma conta?",
          register: "Cadastre-se!",
          showPassword: "Mostrar senha",
          hidePassword: "Ocultar senha",
        },
        footer: {
          rights: "Todos os direitos reservados",
        },
      },
      companies: {
        title: "Empresas",
        form: {
          name: "Nome da Empresa",
          plan: "Plano",
          token: "Token",
          submit: "Cadastrar",
          success: "Empresa criada com sucesso!",
        },
      },
      auth: {
        toasts: {
          success: "Login efetuado com sucesso!",
        },
        dueDate: {
          expiration: "Sua assinatura expira em",
          days: "dias!",
          day: "dia!",
          expirationToday: "Sua assinatura expira hoje!",
        },
        token: "Token",
      },
      dashboard: {
        title: "Dashboard",
        loadingMessage: "Os dados do Dashboard serão carregados em breve...",
        refreshing: "Atualizando dados...",
        pleaseWait: "Por favor, aguarde",
        refresh: "Atualizar dados",
        general: {
          title: "Informações Gerais",
        },
        overview: {
          title: "Visão Geral e Avaliações",
        },
        activity: {
          title: "Atividade por Período e Desempenho",
          daily: "Atividade Diária",
          perHour: "Atividade por Hora",
        },
        distribution: {
          title: "Distribuição por Canal e Setor",
          byChannel: "Distribuição por Canal",
          byQueue: "Distribuição por Setor",
          channels: "canais",
          queues: "setores",
        },
        hourly: {
          title: "Atividade por Hora",
          peak: "Pico",
          between: "Entre",
          and: "e",
        },
        tabs: {
          indicators: "Indicadores",
          assessments: "NPS",
          attendants: "Atendentes",
          weeklyOverview: "Visão Semanal",
        },
        hero: {
          inService: "Em Atendimento",
          ticketsNow: "tickets agora",
          pending: "Pendentes",
          waitingService: "aguardando atendimento",
          criticalTooltip: "Tickets aguardando há mais de 30 minutos",
          critical: "críticos",
          avgWaitTime: "T.M.E. Atual",
          avgWaitLabel: "tempo médio de espera",
          maxWait: "Maior espera",
          nps: "NPS Score",
          npsTooltip: "Net Promoter Score — índice de satisfação do cliente (-100 a +100)",
          promoters: "Promotores",
          passives: "Neutros",
          detractors: "Detratores",
        },
        sections: {
          operational: "Visão Operacional",
          deepAnalysis: "Análise Detalhada",
          aiIntelligence: "Inteligência & IA",
        },
        loading: "Carregando...",
        kpis: {
          resolutionRate: "Resolução",
          resolved: "resolvidos",
          abandonmentRate: "Abandono",
          leftQueue: "saíram da fila",
          slaFirstResponse: "SLA 1ª Resp.",
          under5min: "< 5 min",
          reopened: "Reabertos",
          ticketsReopened: "tickets reabertos",
          finished: "Finalizados",
          closedPeriod: "no período",
          demand: "Demanda",
          activeDemand: "Empresa iniciou",
          passiveDemand: "Cliente iniciou",
          activeVsPassive: "ativa vs passiva",
        },
        health: {
          title: "Saúde do Atendimento",
          excellent: "Excelente",
          attention: "Atenção",
          critical: "Crítico",
          basedOn: "Baseado em",
          indicators: "indicadores",
          pendingQueue: "Pendentes na fila",
          avgWaitTime: "Tempo médio espera",
          slaCompliance: "Cumprimento SLA",
          abandonRate: "Taxa de abandono",
          npsScore: "Score NPS",
        },
        heatmap: {
          title: "Mapa de Calor Semanal",
          less: "Menos",
          more: "Mais",
          peak: "Pico",
          total: "Total",
          avgPerDay: "Média/dia",
          peakSlot: "Pico (2h)",
          days: {
            dom: "Dom",
            seg: "Seg",
            ter: "Ter",
            qua: "Qua",
            qui: "Qui",
            sex: "Sex",
            sab: "Sáb",
          },
        },
        demand: {
          title: "Origem dos Tickets",
          companyInitiated: "Empresa iniciou",
          clientInitiated: "Cliente iniciou",
        },
        ai: {
          title: "IA Autônoma",
          noData: "Nenhum dado de IA autônoma no período",
          totalInteractions: "Interações",
          tokensUsed: "Tokens usados",
          estimatedCost: "Custo est.",
          handoffRate: "Taxa de handoff",
          avgConfidence: "Confiança média",
          handoffReasons: "Motivos de handoff",
          noHandoffs: "Sem handoffs no período",
          reasons: {
            respond: "Respondido",
            handoff: "Handoff",
            ignore: "Ignorado",
            clarify: "Clarificar",
            escalate: "Escalar",
          },
        },
        queues: {
          title: "Filas em Tempo Real",
          noData: "Nenhum dado de filas disponível",
          pending: "Pendentes",
          inProgress: "Em atendimento",
          onlineAgents: "Agentes online",
          moreQueues: "filas adicionais",
          totalPending: "Pendentes",
          totalInProgress: "Atendendo",
          totalOnline: "Online",
        },
        sentiment: {
          title: "Sentimento",
          noData: "Sem dados de sentimento no período",
          positive: "Positivo",
          neutral: "Neutro",
          negative: "Negativo",
          frustrated: "Frustrado",
          score: "Score de",
          satisfaction: "Satisfação",
          total: "total",
        },
        leads: {
          title: "Funil de Leads",
          noData: "Sem dados de leads no período",
          newContacts: "Novos Contatos",
          qualified: "Qualificados",
          negotiation: "Em Negociação",
          converted: "Convertidos",
          conversionRate: "Taxa conversão",
          totalLeads: "Total leads",
          avgTicketValue: "Ticket médio",
          totalValue: "Valor total",
        },
        campaigns: {
          title: "Campanhas",
          noData: "Nenhuma campanha no período",
          sent: "Enviados",
          delivered: "Entregues",
          read: "Lidos",
          failedCount: "Falhas",
          deliveryRate: "Taxa entrega",
          active: "Ativas",
          recent: "Recentes",
          completed: "Concluída",
          running: "Em andamento",
          scheduled: "Agendada",
          failed: "Falhou",
          paused: "Pausada",
        },
        voice: {
          title: "Voice AI",
          noData: "Sem dados de chamadas no período",
          totalCalls: "Chamadas",
          resolutionRate: "Resolução",
          avgDuration: "Duração média",
          cost: "Custo est.",
          outcomes: "Resultados",
          resolved: "Resolvidas",
          transferred: "Transferidas",
          voicemail: "Caixa postal",
          dropped: "Desistência",
          noAnswer: "Sem resposta",
          dailyCalls: "Chamadas por dia",
        },
        charts: {
          perDay: {
            title: "Atendimentos hoje: ",
          },
          messages: "Mensagens",
          ticketFlow: "Fluxo de Tickets",
          opened: "Abertos",
          closed: "Fechados",
          noData: "Sem dados para o período selecionado",
          attendantRanking: "Ranking de Atendentes",
          attendants: "atendentes",
          noAttendants: "Nenhum atendente encontrado",
          name: "Nome",
          tickets: "Tickets",
          avgWait: "TME",
          avgSupport: "TMA",
          rating: "Avaliação",
          channelDist: "Distribuição por Canal",
          totalTickets: "tickets",
          hourlyActivity: "Atividade por Hora",
          peakHour: "Pico",
          pendingByQueue: "Pendentes por Setor",
          pending: "Pendentes",
          total: "total",
          noPending: "Nenhum ticket pendente",
          topContacts: "Top Contatos",
          noContacts: "Nenhum contato encontrado",
          avgServiceTime: "Tempo médio",
          timeMetrics: "Métricas de Tempo",
          avgWaitTime: "T.M.E.",
          avgWaitTimeTooltip: "Tempo Médio de Espera — quanto tempo o cliente espera até ser atendido",
          avgSupportTime: "T.M.A.",
          avgSupportTimeTooltip: "Tempo Médio de Atendimento — duração média de cada atendimento",
          firstResponse: "1ª Resposta",
          firstResponseTooltip2: "Tempo médio até o atendente enviar a primeira mensagem",
          time: "Tempo (min)",
          statusDist: "Distribuição por Status",
          channelTrend: "Tendência por Canal",
          forecast: "Previsão",
        },
        messageVolume: {
          title: "Volume de Mensagens",
          tooltip: "Total de mensagens enviadas, recebidas e falhas no envio por dia",
          sent: "Enviadas",
          received: "Recebidas",
          failed: "Falhas",
          failureRate: "Taxa",
          failureRateTooltip: "Percentual de mensagens que falharam sobre o total enviado",
          topErrors: "Principais erros de envio",
          noData: "Sem dados de mensagens para o período",
        },
        total: "Total",
        noData: "Sem dados disponíveis",
        cards: {
          inAttendance: "Em Atendimento",
          waiting: "Aguardando",
          activeAttendants: "Atendentes Ativos",
          finalized: "Finalizados",
          newContacts: "Novos Contatos",
          totalReceivedMessages: "Mensagens Recebidas",
          totalSentMessages: "Mensagens Enviadas",
          averageServiceTime: "Atendimento",
          averageWaitingTime: "Espera",
          status: "Status (Atual)",
          activeTickets: "Tickets Ativos",
          passiveTickets: "Tickets Passivos",
          groups: "Grupos",
          totalTickets: "Total de Tickets",
          // Novas métricas de pendentes
          avgWaitTimeNow: "T.M.E. Atual",
          maxWaitTimeNow: "Maior Espera",
          criticalPending: "Pendentes Críticos",
          abandonmentRate: "Taxa Abandono",
          firstResponseSLA: "SLA 1ª Resposta",
        },
        // Tooltips das novas métricas
        avgWaitTimeNowTooltip: "Tempo médio de espera dos tickets pendentes agora",
        maxWaitTimeNowTooltip: "Tempo de espera do ticket mais antigo na fila",
        criticalPendingTooltip: "Tickets aguardando há mais de 30 minutos",
        abandonmentRateTooltip: "Tickets fechados antes de serem atendidos",
        firstResponseSLATooltip: "Percentual de tickets atendidos em menos de 5 minutos",
        pendingNow: "Pendentes agora",
        bottleneck: "Gargalo atual",
        over30min: "> 30 min de espera",
        closedBeforeService: "Fechados sem atendimento",
        under5min: "Atendidos em < 5 min",
        // Seção de pendentes por setor
        pendingByQueue: {
          sectionTitle: "Monitoramento de Pendentes por Setor",
          title: "Pendentes por Setor",
          pending: "Pendentes",
          total: "pendentes",
          totalTooltip: "Total de tickets aguardando atendimento",
          ok: "< 15 min",
          alert: "15-30 min",
          critical: "> 30 min",
          empty: "Nenhum ticket pendente",
          emptySubtext: "Todos os setores estão em dia!",
          avgWait: "Espera média",
        },
        noQueue: "Sem setor",
        users: {
          name: "Nome",
          numberAppointments: "Quantidade de Atendimentos",
          statusNow: "Atual",
          totalCallsUser: "Total de atendimentos por usuário",
          totalAttendances: "Total de atendimentos",
        },
        date: {
          initialDate: "Data Inicial",
          finalDate: "Data Final",
        },
        filters: {
          title: "Filtros",
          apply: "Filtrar",
          reset: "Limpar Filtros",
          quickFilters: "Filtros Rápidos",
          customRange: "Período Personalizado",
          allTime: "Todo o Período",
          today: "Hoje",
          yesterday: "Ontem",
          last7days: "Últimos 7 dias",
          thisWeek: "Esta semana",
          thisMonth: "Este mês",
          lastMonth: "Mês passado",
          sections: "Visibilidade das Seções",
          refreshInterval: "Intervalo de atualização:",
          refreshManual: "Manual",
          refresh5min: "5 minutos",
          refresh15min: "15 minutos",
          refresh30min: "30 minutos",
          until: "até",
          hideSection: "Ocultar seção",
          showAll: "Mostrar Todas",
          hideAll: "Ocultar Todas",
          queuePlaceholder: "Filtrar por setor",
          noQueues: "Nenhum setor",
          userPlaceholder: "Filtrar por atendente",
          noUsers: "Nenhum atendente",
          connectionPlaceholder: "Filtrar por conexão",
          noConnections: "Nenhuma conexão",
        },
        assessments: {
          totalCalls: "Total de Atendimentos",
          callsWaitRating: "Atendimentos aguardando avaliação",
          callsWithoutRating: "Atendimentos sem avaliação",
          ratedCalls: "Atendimentos avaliados",
          evaluationIndex: "Índice de avaliação",
          score: "Pontuação",
          prosecutors: "Promotores",
          neutral: "Neutros",
          detractors: "Detratores",
          ratingTooltip: "dos tickets avaliados",
        },
        tickets: {
          overview: "Status dos Tickets",
          timeline: "Timeline de Atendimentos",
          created: "Tickets Criados",
          active: "Tickets ativos atualmente",
          pending: "Tickets aguardando atendimento",
          completed: "Atendimentos concluídos",
          demandActive: "Demanda ativa",
          demandPassive: "Demanda passiva",
          inAttendanceTooltip: "Tickets que estão sendo atendidos no momento",
          waitingTooltip:
            "Tickets que ainda não foram atribuídos a um atendente",
          finalizedTooltip: "Tickets que foram fechados e resolvidos",
          activeTicketsTooltip: "Tickets que foram iniciados pela empresa",
          passiveTicketsTooltip: "Tickets que foram iniciados pelo cliente",
        },
        messages: {
          title: "Mensagens por Período",
          received: "Recebidas",
          sent: "Enviadas",
          total: "Total",
          ratio: "Proporção",
        },
        attendants: {
          performance: "Ranking de Atendentes",
          online: "Online agora",
        },
        topContacts: {
          title: "Ranking de Contatos",
          columns: {
            contact: "Contato",
            tickets: "Tickets",
            queue: "Setor",
            time: "Tempo",
          },
          noData: "Sem contatos para exibir",
          tooltip: "Top 10 contatos com mais tickets abertos no período",
          openTicket: "Abrir ticket",
          statusOpen: "Aberto",
          statusPending: "Pendente",
          statusClosed: "Fechado",
        },
        actions: {
          filter: "Filtrar",
          refresh: "Atualizar",
          fullscreen: "Tela cheia",
          exitFullscreen: "Sair da tela cheia",
        },
        online: "Online agora",
        serviceTime: "Tempo médio de atendimento",
        waitingTime: "Tempo médio de espera na fila",
        newContacts: "Novos contatos no período",
        fromLastMonth: "desde o mês passado",
        newContactsTooltip: "Novos contatos registrados no período selecionado",
        activeAttendantsTooltip: "Número de atendentes disponíveis online",
        timeMetrics: "Métricas de Tempo",
        firstResponseTooltip:
          "Tempo médio até a primeira resposta do atendente",
        resolutionRateTooltip:
          "Percentual de tickets resolvidos em relação ao total",
        reopenedTicketsTooltip: "Tickets que foram reabertos após fechamento",
        avgTicketsPerDayTooltip: "Média diária de tickets no período",
        firstResponseTime: "Primeira Resposta",
        sort: {
          ascending: "Crescente",
          descending: "Decrescente",
          orderBy: "Ordenar por",
          tickets: "Número de Tickets",
          rating: "Avaliação",
          waitTime: "Tempo de Espera",
          serviceTime: "Tempo de Atendimento",
        },
        status: {
          open: "Abertos",
          pending: "Pendentes",
          closed: "Fechados",
          nps: "Avaliação",
        },
        export: {
          pdf: "Exportar PDF",
        },
        sla: {
          detailTitle: "SLA 1ª Resposta Detalhado",
          under1min: "< 1 min",
          "1to5min": "1-5 min",
          "5to15min": "5-15 min",
          "15to30min": "15-30 min",
          over30min: "> 30 min",
          totalResponses: "Total de respostas",
          under5min: "Respondidos < 5 min",
          noData: "Sem dados de SLA para o período",
        },
        goals: {
          target: "Meta",
        },
        alerts: {
          highWaitTime: "TME atual acima de 10 minutos ({{value}} min)",
          criticalPending: "Há {{count}} tickets críticos sem resposta",
          highAbandonment: "Taxa de abandono elevada: {{rate}}%",
          npsDrop: "NPS caiu {{delta}} pontos em relação ao período anterior",
        },
        callbacks: {
          title: "Retornos & Transferências",
          noData: "Sem reaberturas ou transferências no período",
          reopened: "Reaberturas",
          transfers: "Transferências",
          uniqueReopened: "Tickets Reabertos",
        },
        aiInsights: {
          title: "Insights com IA",
          generate: "Gerar Insights",
          generating: "Gerando insights...",
          empty: "Clique para gerar insights sobre seus dados",
          error: "Erro ao gerar insights",
        },
        geo: {
          title: "Distribuição Geográfica",
          noData: "Sem dados geográficos no período",
          totalStates: "Estados",
          totalTickets: "Total de Tickets",
        },
      },
      todo: {
        newTask: "Nova Tarefa",
        add: "Adicionar",
        task: "Tarefas",
      },

      contactImportWpModal: {
        title: "Exportar Contatos para CSV",
        buttons: {
          downloadModel: "Download modelo CSV para importação",
          closed: "Fechar",
          import: "Selecione o arquivo CSV para importar Contatos",
        },
      },
      connections: {
        title: "Conexões",
        waitConnection: "Aguarde, reiniciando conexões...",
        callSupport: "Suporte",
        newConnection: "Nova conexão",
        restartConnections: "Reiniciar conexões",
        online: "Online",
        offline: "Desconectado",
        warning: "Pendente",
        check: "Verificar",
        facebook: {
          success:
            "Facebook conectado com sucesso! Agora configure suas páginas.",
        },
        toasts: {
          deleted: "Conexão excluída com sucesso!",
          closedimported: "Tickets importados foram fechados com sucesso!",
          importStopped: "Processo de importação interrompido com sucesso!",
          importStarted:
            "Processo de importação iniciado! Aguarde a preparação das mensagens.",
          qrCodeScanned:
            "QR Code lido com sucesso! Iniciando preparação para importação...",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Tem certeza? Esta ação não pode ser revertida.",
          disconnectTitle: "Desconectar",
          disconnectMessage:
            "Tem certeza? Você precisará ler o QR Code novamente.",
          closedImportedTitle: "Fechar Tickets Importados",
          closedImportedMessage:
            "Tem certeza? Todos os tickets importados serão fechados.",
          transferLabel: "Selecione a nova conexão para os tickets",
          transferHelper:
            "Os tickets serão mantidos nas mesmas filas após a transferência.",
          transferUnavailable:
            "Nenhuma outra conexão desse canal está disponível. Crie uma nova conexão antes de excluir.",
          noTransferOption:
            "Nenhuma outra conexão desse canal disponível para transferência. Se houver tickets ou contatos, eles serão perdidos.",
        },
        buttons: {
          add: "Adicionar WhatsApp",
          disconnect: "Desconectar",
          restart: "Reiniciar",
          resume: "Retomar",
          pause: "Pausar",
          tryAgain: "Tentar novamente",
          qrcode: "QR CODE",
          newQr: "Novo QR Code",
          connecting: "Conectando",
          preparing: "Preparando mensagens",
          importing: "Importando mensagens",
          closedImported: "Fechar importados",
          stopImport: "Parar importação",
          resolvePasskey: "Resolver autenticação",
        },
        toolTips: {
          disconnected: {
            title: "Falha na conexão com o WhatsApp",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e tente novamente, ou solicite um novo QR Code",
          },
          qrcode: {
            title: "Aguardando leitura do QR Code",
            content:
              "Clique no botão 'QR CODE' e leia o QR Code com o seu celular para iniciar a conexão",
          },
          connected: {
            title: "Conexão estabelecida",
          },
          timeout: {
            title: "A conexão com o celular foi perdida",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e o WhatsApp esteja aberto, ou clique em 'Desconectar' para obter um novo QR Code",
          },
          importing: {
            title: "Importação em andamento",
            content:
              "Suas mensagens estão sendo importadas. Este processo pode levar algum tempo dependendo da quantidade de mensagens.",
          },
          preparing: {
            title: "Preparando importação",
            content:
              "Estamos analisando suas mensagens do período selecionado. Aguarde enquanto preparamos tudo para a importação.",
          },
        },
        table: {
          name: "Nome",
          status: "Status",
          lastUpdate: "Atualizado em",
          default: "Padrão",
          actions: "Ações",
          session: "Sessão",
        },
        status: {
          connected: "Online",
          disconnected: "Offline",
          opening: "Abrindo",
          qrcode: "QR",
          timeout: "Tempo esgotado",
          pairing: "Pareando",
          preparing: "Preparando",
          importing: "Importando",
          passkeyRequired: "Passkey necessária",
        },
        badges: {
          default: "Padrão",
        },
        typography: {
          processed: "Processado",
          in: "de",
          date: "Data",
          preparingMessages:
            "Aguarde enquanto preparamos suas mensagens para importação...",
          analyzingMessages: "Analisando mensagens do período selecionado...",
          importStarted: "Importação iniciada! Não feche esta janela.",
          importInProgress:
            "Importação em andamento. Isso pode levar alguns minutos.",
          qrCodeSuccess:
            "QR Code lido com sucesso! Iniciando preparação para importação...",
        },
        importStatus: {
          preparing: "Preparando importação",
          analyzing: "Analisando mensagens",
          importing: "Importando mensagens",
          finishing: "Finalizando importação",
          completed: "Importação concluída",
        },
      },
      showTicketOpenModal: {
        title: {
          header: "Atendimento Existente",
        },
        form: {
          message: "Este contato já está em atendimento:",
          user: "Atendente",
          queue: "Fila",
          messageWait:
            "Este contato já está aguardando atendimento. Veja na aba Aguardando!",
        },
      },
      showTicketLogModal: {
        title: {
          header: "Logs",
        },
        options: {
          create: "Ticket criado.",
          chatBot: "ChatBot iniciado.",
          queue: " - Fila definida.",
          open: " iniciou o atendimento.",
          access: "acessou o ticket.",
          transfered: "transferiu o ticket.",
          receivedTransfer: "recebeu o ticket transferido.",
          pending: "devolveu a fila.",
          closed: "fechou o ticket",
          reopen: "reabriu o ticket",
          redirect: "- redirecionado",
        },
      },
      whatsappModal: {
        title: {
          add: "Adicionar WhatsApp",
          edit: "Editar WhatsApp",
        },
        tabs: {
          general: "Geral",
          integrations: "Integrações",
          messages: "Mensagens",
          chatbot: "Chatbot",
          assessments: "Avaliações",
          schedules: "Horários",
        },
        form: {
          name: "Nome",
          default: "Padrão",
          group: "Permitir Grupos",
          groupAsTicket: "Grupos como Tickets",
          importOldMessagesEnable: "Importar mensagens antigas",
          importOldMessagesGroups: "Importar mensagens de grupos",
          closedTicketsPostImported: "Fechar tickets após importação",
          importOldMessages: "Data inicial para importação",
          importRecentMessages: "Data final para importação",
          queueIdImportMessages: "Fila para mensagens importadas",
          token: "Token",
          sendIdQueue: "Fila para redirecionamento",
          timeSendQueue: "Tempo em minutos",
          greetingMessage: "Mensagem de saudação",
          complationMessage: "Mensagem de conclusão",
          outOfHoursMessage: "Mensagem fora do horário",
          ratingMessage: "Mensagem de avaliaçao - Escala deve ser de 0 a 10",
          collectiveVacationMessage: "Mensagem de férias coletivas",
          collectiveVacationStart: "Início das férias coletivas",
          collectiveVacationEnd: "Fim das férias coletivas",
          timeCreateNewTicket: "Criar novo ticket em x minutos",
          maxUseBotQueues: "Enviar bot x vezes",
          timeUseBotQueues: "Enviar bot em x minutos",
          expiresTicket: "Encerrar chats abertos após x minutos",
          whenExpiresTicket: "Encerrar quando última mensagem for",
          closeLastMessageOptions1: "Após última mensagem do cliente",
          closeLastMessageOptions2: "Após última mensagem do atendente",
          expiresInactiveMessage: "Mensagem de encerramento por inatividade",
          timeInactiveMessage:
            "Tempo em minutos para envio do aviso de inatividade",
          inactiveMessage: "Mensagem de inatividade",
          maxUseBotQueuesNPS:
            "Máximo de vezes que a avaliação deve ser enviada",
          expiresTicketNPS:
            "Encerrar chats aguardando avaliação após x minutos",
          prompt: "Prompt para IA",
          queueRedirection: "Redirecionamento de Fila",
          queueRedirectionDesc:
            "Redirecionar para uma fila após um tempo sem resposta",
          importAlert:
            "ATENÇÃO: Ao habilitar a importação de mensagens, será necessário ler o QR Code novamente. Após a conexão ser estabelecida, o processo de preparação e importação será iniciado automaticamente.",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          addImage: "Adicionar Imagem/Vídeo",
        },
        menuItem: {
          enabled: "Habilitado",
          disabled: "Desabilitado",
        },
        success: "WhatsApp salvo com sucesso.",
        importWarning:
          "Atenção: Habilitar importação irá desconectar a sessão atual para reconectar novamente.",
        errorRatingMessage:
          "Mensagem de avaliação é obrigatória quando as avaliações estão habilitadas.",
        errorExpiresNPS:
          "Tempo para expirar ticket NPS é obrigatório quando as avaliações estão habilitadas.",
        errorSendQueue:
          "Selecione uma fila para redirecionamento quando o tempo for maior que zero.",
        errorGreetingMessage:
          "Mensagem de saudação é obrigatória quando duas ou mais filas são selecionadas.",
        queueRequired:
          "É necessário selecionar uma fila para importação de mensagens.",
        vacationDatesRequired:
          "As datas de início e fim das férias coletivas são obrigatórias quando a mensagem de férias está preenchida.",
        invalidDates:
          "A data de início não pode ser posterior à data de fim das férias coletivas.",
        errorExpiresInactiveMessage:
          "Mensagem de encerramento por inatividade é obrigatória quando o tempo de expiração de ticket está configurado.",
        errorTimeInactiveMessage:
          "Tempo para envio do aviso de inatividade é obrigatório quando a mensagem de inatividade está preenchida.",
        npsDisabled:
          "NPS está desabilitado nas configurações da empresa. Configure em: Configurações > Empresa",
        queueSelected:
          "Filas selecionadas. O Prompt e as Integrações estão desabilitados.",
        promptSelected:
          "Prompt selecionado. As Filas e Integrações estão desabilitadas.",
        integrationSelected:
          "Integração selecionada. As Filas e o Prompt estão desabilitados.",
        importInfo:
          "A conexão será reiniciada para importar as mensagens. Aguarde o processo de reconexão e importação.",
        status: {
          connected: "Online",
          opening: "Abrindo",
          qrcode: "QR",
          disconnected: "Offline",
          timeout: "Timeout",
          pairing: "Pareando",
          destroyed: "Destruído",
        },
      },
      qrCode: {
        message: "Leia o QrCode para iniciar a sessão",
        passkey: {
          modalTitle: "Resolver passkey",
          title: "Autenticação por passkey necessária",
          detecting: "Detectando a extensão...",
          connectingTitle: "Conectando...",
          connecting: "Sessão enviada. Aguardando o WhatsApp conectar...",
          ready: {
            description:
              "Esta conexão precisa de uma nova autenticação do WhatsApp. Clique abaixo para resolver com segurança pela extensão do navegador.",
          },
          install: {
            title: "Instale a extensão para continuar",
            description:
              "A resolução do passkey é feita por uma extensão de navegador. Instale-a e recarregue esta página.",
            step1: "Baixe a extensão (arquivo .crx ou pasta descompactada).",
            step2: "Abra chrome://extensions e ative o Modo do desenvolvedor.",
            step3: "Clique em 'Carregar sem compactação' e selecione a pasta da extensão.",
            step4: "Recarregue esta página para detectar a extensão.",
          },
          existingSession: {
            title: "Outra conta já está conectada",
            message: "Já existe uma conta conectada neste navegador:",
            unknownNumber: "outra conta",
            question: "Deseja desconectá-la e continuar?",
          },
          buttons: {
            resolve: "Resolver autenticação",
            retry: "Tentar de novo",
            cancel: "Cancelar",
            clearAndContinue: "Desconectar e continuar",
            migrateToWaba: "Migrar para WABA oficial",
          },
          errors: {
            noUrl: "Não foi possível obter a URL de importação. Tente novamente.",
            generic: "Falha ao importar a sessão. Tente novamente.",
            withReason: "Falha ao importar a sessão: {{reason}}",
          },
          connectionFailed: {
            title: "Não foi possível conectar",
            description:
              "A sessão foi importada, mas a conexão com o WhatsApp falhou. Tente novamente.",
            withReason: "Não foi possível conectar: {{reason}}",
            timeoutTitle: "Não foi possível conectar — tempo esgotado",
            timeoutDescription:
              "A sessão foi importada, mas não recebemos confirmação da conexão a tempo. Tente novamente.",
          },
        },
      },
      contacts: {
        title: "Contatos",
        toasts: {
          deleted: "Contato excluído com sucesso!",
          deletedAll: "Todos os contatos foram excluídos com sucesso!",
          deleteAllQueued: "Exclusão em massa enfileirada. Aguarde o início...",
          deleteAllStarted: "Exclusão em massa iniciada.",
          deleteAllInProgress: "Excluindo contatos...",
          deleteAllCompleted: "Exclusão em massa concluída.",
          deleteAllError: "Erro ao executar exclusão em massa.",
          invalidConfirmation:
            "Confirmação inválida. Digite DELETAR em maiúsculas.",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle: "Deletar ",
          importTitlte: "Importar contatos",
          exportContact: "Exportar contatos",
          deleteMessage:
            "Tem certeza que deseja deletar este contato? Todos os atendimentos relacionados serão perdidos.",
          blockContact: "Tem certeza que deseja bloquear este contato?",
          unblockContact: "Tem certeza que deseja desbloquear este contato?",
          importMessage: "Deseja importar todos os contatos do telefone?",
          importChat: "Importar Conversas",
          wantImport: "Deseja importar todas as conversas do telefone?",
          deleteAllTitle: "Excluir TODOS os contatos?",
          deleteAllMessage:
            "Esta ação irá excluir TODOS os contatos e não poderá ser desfeita.",
          deleteAllWarning: "Digite DELETAR em maiúsculas para confirmar:",
          deleteAllFinalTitle: "ATENÇÃO: Última verificação",
          deleteAllFinalMessage:
            "Você tem certeza absoluta que deseja excluir TODOS os contatos do sistema? Esta ação não poderá ser desfeita.",
        },
        buttons: {
          import: "Importar Contatos",
          add: "Adicionar Contato",
          export: "Exportar Contato",
          deleteAll: "Excluir Todos",
        },
        table: {
          name: "Nome",
          whatsapp: "Conexão",
          email: "Email",
          actions: "Ações",
          lastMessage: "Última Mensagem",
          number: "Número",
        },
        menu: {
          importYourPhone: "Importar do aparelho padrão",
          importToExcel: "Importar / Exportar Contatos",
        },
      },
      forwardMessage: {
        text: "Encaminhada",
      },
      forwardMessageModal: {
        title: "Encaminhar mensagem",
        buttons: {
          ok: "Encaminhar",
        },
      },
      forwardMessageBar: {
        messagesSelected: "selecionadas",
        selectMessages: "Selecione mensagens",
        forward: "Encaminhar",
      },
      promptModal: {
        form: {
          name: "Nome",
          prompt: "Prompt",
          voice: "Voz",
          max_tokens: "Máximo de Tokens na resposta",
          temperature: "Temperatura",
          apikey: "API Key",
          max_messages: "Máximo de mensagens no Histórico",
          voiceKey: "Chave da API de Voz",
          voiceRegion: "Região de Voz",
          basicInfo: "Informações Básicas",
          voiceSettings: "Configurações de Voz",
          aiSettings: "Configurações de IA",
          queueLabel: "Selecione a fila",
        },
        success: "Prompt salvo com sucesso!",
        title: {
          add: "Adicionar Prompt",
          edit: "Editar Prompt",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
      },
      prompts: {
        title: "Prompts",
        table: {
          name: "Nome",
          queue: "Setor/Fila",
          max_tokens: "Máximo Tokens Resposta",
          actions: "Ações",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida!",
        },
        buttons: {
          add: "Adicionar Prompt",
        },
      },
      aiConfigurations: {
        title: "Configurações de IA",
        table: {
          name: "Nome",
          provider: "Provedor",
          model: "Modelo",
          features: "Funcionalidades",
          status: "Status",
          actions: "Ações",
        },
        confirmationModal: {
          deleteTitle: "Excluir Configuração",
          deleteMessage: "Tem certeza que deseja excluir esta configuração de IA?",
        },
        buttons: {
          add: "Nova Configuração",
          test: "Testar Conexão",
          save: "Salvar",
          cancel: "Cancelar",
        },
        form: {
          name: "Nome da Configuração",
          provider: "Provedor",
          model: "Modelo",
          apiKey: "API Key",
          maxTokens: "Max Tokens",
          temperature: "Temperatura",
          systemPrompt: "Prompt do Sistema",
        },
        features: {
          chat: "Chat",
          summarize: "Sumarização",
          suggest: "Sugestões",
          transcribe: "Transcrição",
        },
        providers: {
          openai: "OpenAI",
          gemini: "Google Gemini",
          claude: "Anthropic Claude",
          grok: "xAI Grok",
        },
        messages: {
          testSuccess: "Conexão bem-sucedida!",
          testError: "Erro ao testar conexão",
          createSuccess: "Configuração criada com sucesso!",
          updateSuccess: "Configuração atualizada com sucesso!",
          deleteSuccess: "Configuração excluída com sucesso!",
        },
      },
      // Wizard de Configuração de IA
      aiConfigurationWizard: {
        title: "Criar Configuração de IA",
        editTitle: "Editar Configuração de IA",
        success: "Configuração criada com sucesso!",
        updateSuccess: "Configuração atualizada com sucesso!",
        optional: "Opcional",
        back: "Voltar",
        next: "Próximo",
        skip: "Pular",
        close: "Fechar",
        create: "Criar Configuração",
        update: "Salvar Alterações",
        saving: "Salvando...",
        updating: "Atualizando...",
        steps: {
          basic: "Tipo",
          provider: "Provedor",
          behavior: "Comportamento",
          autonomous: "Autônomo",
          classifier: "Categorias",
          integrations: "Integrações",
          review: "Revisão",
        },
        selectType: "Selecione o tipo de IA",
        selectTypeSubtitle: "Esta é a primeira decisão e define todo o resto do assistente. A diferença principal é se a IA fala ou não com o cliente.",
        whenToUseLabel: "Quando usar: ",
        types: {
          assistant: {
            title: "Assistente",
            badge: "Apoia o atendente",
            description: "Não fala com o cliente. Gera sugestões de resposta, resumos e análises para o atendente humano decidir.",
            whenToUse: "O atendimento continua humano, mas mais rápido com ajuda da IA.",
          },
          autonomous: {
            title: "Modo Autônomo",
            badge: "Fala com o cliente",
            description: "Conversa diretamente com o cliente e resolve sozinho, transferindo para um humano quando necessário.",
            whenToUse: "Você quer que a IA atenda de ponta a ponta, sem humano no loop.",
          },
          classifier: {
            title: "Classificador",
            badge: "Só direciona",
            description: "Não conversa. Identifica a intenção da mensagem e encaminha o ticket para a fila ou agente certo.",
            whenToUse: "Você quer triagem automática antes de cair em fila/atendente.",
          },
        },
        prompts: {
          sectionTitle: "Prompts da IA",
          mainLabel: "Prompt Principal",
          mainBadge: "Base · usado sempre",
          autonomousLabel: "Instruções do Modo Autônomo",
          autonomousBadge: "Só quando atende sozinha",
          classifierSectionTitle: "Prompts do Classificador",
          classifierMainLabel: "Prompt de Classificação",
          classifierMainBadge: "Como classificar · opcional",
          classifierPersonaLabel: "Persona e Conhecimento",
          classifierPersonaBadge: "Usada no probing · opcional",
          classifierTransitionLabel: "Mensagem de Transição",
          classifierTransitionBadge: "Ao transferir · opcional",
        },
        configName: "Nome da Configuração",
        configNamePlaceholder: "Ex: Suporte Técnico, Vendas, Classificador Principal...",
        configNameHelper: "Um nome descritivo para identificar esta configuração",
        activeConfig: "Configuração Ativa",
        activeConfigHelper: "Desative para pausar temporariamente esta IA",
        selectProvider: "Selecione o Provedor",
        selectModel: "Modelo",
        modelPlaceholder: "Selecione ou digite o modelo",
        apiKey: "API Key",
        apiKeyPlaceholder: "Cole sua API Key aqui",
        apiKeyRequired: "Informe a API Key",
        connectionSuccess: "Conexão bem-sucedida!",
        connectionFailed: "Falha na conexão",
        connectionError: "Erro ao testar conexão",
        testing: "Testando...",
        testConnection: "Testar Conexão",
        testConnectionHint: "Recomendamos testar a conexão antes de continuar",
        advancedSettings: "Configurações Avançadas",
        customEndpoint: "Endpoint Personalizado (opcional)",
        customEndpointHelper: "Use para proxies ou endpoints alternativos",
        systemPrompt: "Prompt do Sistema",
        systemPromptHelper: "Defina a personalidade e comportamento da IA",
        useTemplate: "Usar template:",
        promptPlaceholder: "Digite as instruções para a IA...",
        maxTokens: "Max Tokens (por resposta)",
        maxTokensTooltip: "Limite máximo de tokens em UMA resposta da IA. Não confundir com o 'Máx. Tokens por Sessão' (orçamento do atendimento inteiro, no step Autônomo).",
        temperature: "Temperatura",
        temperatureTooltip: "Controla a criatividade das respostas",
        features: "Funcionalidades Adicionais",
        featuresHelper: "Habilite funcionalidades extras (opcionais)",
        feature: {
          enableSuggestions: "Sugestões",
          enableSummarization: "Sumarização",
          enableTranslation: "Tradução",
          enableTranscription: "Transcrição",
        },
        autonomousMode: "Modo Autônomo",
        autonomousModeDescription: "A IA responde automaticamente sem intervenção humana",
        autonomousPrompt: "Instruções Complementares para Atendimento Autônomo",
        autonomousPromptHelper: "Instruções adicionais usadas somente quando a IA está atendendo sozinha. Complementa o prompt principal — não o substitui (opcional)",
        autonomousPromptPlaceholder: "Ex: Quando atender sozinha, seja mais direta e objetiva. Limite respostas a 3 frases...",
        autonomousPromptTip: "Estas instruções são adicionadas ao Prompt Principal somente quando a IA está respondendo automaticamente (sem humano).",
        autonomousDisabledInfo: "O modo autônomo está desabilitado. A IA funcionará apenas como assistente para atendentes.",
        classifierTitle: "Categorias de Intenção",
        classifierDescription: "Configure as categorias para classificar mensagens e direcionar automaticamente",
        classifierTip: "Dica: Adicione palavras-chave relevantes em cada categoria para melhorar a precisão da classificação. Você também pode vincular cada categoria a uma fila específica ou a um agente de IA especializado.",
        aiTools: "AI Tools (Function Calling)",
        aiToolsHelper: "Selecione as ferramentas que a IA poderá usar para consultar sistemas externos",
        noToolsAvailable: "Nenhuma AI Tool disponível",
        createToolsHint: "Crie AI Tools na página de ferramentas",
        specificQueue: "Fila Específica (opcional)",
        allQueues: "Todas as filas",
        specificModels: "Modelos Específicos por Funcionalidade",
        specificModelsHelper: "Configure modelos diferentes para cada funcionalidade (deixe vazio para usar o modelo principal)",
        sentimentAnalysis: "Análise de Sentimento",
        voiceTTS: "Voz (Text-to-Speech)",
        reviewTitle: "Tudo pronto!",
        reviewSubtitle: "Revise as configurações e clique em \"Criar Configuração\"",
        basicInfo: "Informações Básicas",
        provider: "Provedor",
        behavior: "Comportamento",
        integrations: "Integrações",
        promptPreview: "Prompt do Sistema",
        quickTest: "Teste Rápido (Opcional)",
        testPlaceholder: "Digite uma mensagem para testar a IA...",
        testOptional: "O teste é opcional. Você pode criar a configuração e testar depois.",
      },
      aiSuggestions: {
        title: "Sugestões de IA",
        loading: "Gerando sugestões...",
        empty: "Nenhuma sugestão disponível",
        refresh: "Recarregar sugestões",
        tones: {
          friendly: "amigável",
          formal: "formal",
          neutral: "neutro",
        },
      },
      aiSummarize: {
        title: "Resumo da Conversa",
        loading: "Analisando conversa...",
        button: "Resumir conversa com IA",
        sections: {
          summary: "Resumo",
          keyPoints: "Pontos Principais",
          actionItems: "Pendências",
          sentiment: "Sentimento",
        },
        sentiments: {
          positive: "Positivo",
          negative: "Negativo",
          neutral: "Neutro",
          mixed: "Misto",
        },
      },
      common: {
        cancel: "Cancelar",
        next: "Próximo",
        back: "Voltar",
        save: "Salvar",
        saving: "Salvando...",
        close: "Fechar",
        confirm: "Confirmar",
        delete: "Excluir",
        edit: "Editar",
        add: "Adicionar",
        search: "Buscar",
        loading: "Carregando...",
        yes: "Sim",
        no: "Não",
        ok: "OK",
      },
      aiTools: {
        title: "Integrações IA",
        steps: {
          connector: "Conector",
          endpoint: "Endpoint",
          parameters: "Parâmetros",
          response: "Resposta",
          access: "Acesso",
        },
        table: {
          name: "Nome",
          endpoint: "Endpoint",
          category: "Categoria",
          stats: "Estatísticas",
          status: "Status",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Integração",
          refresh: "Atualizar",
          createFirst: "Criar primeira integração",
        },
        filters: {
          search: "Buscar por nome...",
          category: "Categoria",
          status: "Status",
          all: "Todos",
          active: "Ativo",
          inactive: "Inativo",
        },
        status: {
          active: "Ativo",
          inactive: "Inativo",
        },
        actions: {
          test: "Testar",
          logs: "Ver logs",
          edit: "Editar",
          delete: "Excluir",
        },
        stats: {
          executions: "execuções",
        },
        empty: {
          noTools: "Nenhuma integração configurada",
          noResults: "Nenhum resultado encontrado",
          description: "Configure integrações para que a IA possa interagir com sistemas externos.",
        },
        confirmDelete: {
          title: "Excluir Integração",
          message: "Tem certeza que deseja excluir a integração '{{name}}'?",
        },
        messages: {
          createSuccess: "Integração criada com sucesso!",
          updateSuccess: "Integração atualizada com sucesso!",
          deleteSuccess: "Integração excluída com sucesso!",
          activated: "Integração ativada!",
          deactivated: "Integração desativada!",
        },
        modal: {
          titleCreate: "Nova Integração",
          titleEdit: "Editar Integração",
          selectConnector: "Selecione um conector",
          selectTemplate: "Selecione um template",
          configureEndpoint: "Configurar endpoint",
          authentication: "Autenticação",
          configureParameters: "Configurar parâmetros",
          parametersDescription: "Defina os parâmetros que a IA pode passar para esta integração.",
          configureResponse: "Configurar resposta",
          configureAccess: "Controle de acesso",
        },
        fields: {
          name: "Nome técnico",
          nameHelp: "Usado internamente (ex: criar_atendimento)",
          displayName: "Nome de exibição",
          description: "Descrição",
          descriptionHelp: "Descreva o que esta integração faz para a IA entender quando usá-la.",
          baseUrl: "URL Base",
          path: "Caminho (path)",
          method: "Método HTTP",
          username: "Usuário",
          password: "Senha",
          headerName: "Nome do Header",
          successPath: "JSONPath de sucesso",
          successTemplate: "Template de sucesso",
          templateHelp: "Use {{result}} para inserir o valor extraído",
          jsonPathHelp: "Ex: $.data.id ou $.response.ticket_id",
          errorPath: "JSONPath de erro",
          errorTemplate: "Template de erro",
          isActive: "Integração ativa",
          allowedQueues: "Filas permitidas",
          allowedQueuesPlaceholder: "Selecione as filas...",
          allowedQueuesHelp: "Deixe vazio para permitir em todas as filas",
          allowedAgents: "Agentes de IA permitidos",
          allowedAgentsPlaceholder: "Selecione os agentes...",
          allowedAgentsHelp: "Deixe vazio para permitir em todos os agentes",
          allowedContactNumbers: "Telefones autorizados (whitelist)",
          allowedContactNumbersHelp: "Deixe vazio para permitir qualquer contato. Quando preenchido, apenas estes números poderão executar esta tool.",
          allowedContactNumbersWarning: "Atenção: apenas {{count}} número(s) autorizado(s) poderão executar esta ferramenta. Contatos não autorizados receberão uma mensagem de acesso negado.",
        },
        parameters: {
          name: "Nome",
          type: "Tipo",
          description: "Descrição",
          required: "Obrigatório",
          expand: "Opções avançadas",
          remove: "Remover",
          add: "Adicionar parâmetro",
          addFirst: "Adicionar primeiro parâmetro",
          empty: "Nenhum parâmetro definido. A IA não poderá passar dados para esta integração.",
          advanced: "Opções avançadas",
          default: "Valor padrão",
          minLength: "Min. caracteres",
          maxLength: "Máx. caracteres",
          min: "Valor mínimo",
          max: "Valor máximo",
          enumValues: "Valores permitidos",
          addEnumValue: "Adicionar valor",
        },
        test: {
          title: "Testar Integração",
          parameters: "Parâmetros de teste",
          noParameters: "Esta integração não requer parâmetros.",
          dryRun: "Modo simulação (dry run)",
          dryRunDescription: "Não executa a chamada real, apenas valida os parâmetros.",
          dryRunWarning: "Modo simulação ativo. A chamada real não será executada.",
          execute: "Executar teste",
          testing: "Testando...",
          result: "Resultado",
          rawResponse: "Resposta completa",
          request: "Requisição que seria enviada",
          selectOption: "Selecione...",
        },
        logs: {
          title: "Logs de Execução",
          totalExecutions: "Total de execuções",
          successRate: "Taxa de sucesso",
          avgLatency: "Latência média",
          errors: "Erros",
          status: "Status",
          startDate: "Data inicial",
          endDate: "Data final",
          date: "Data",
          latency: "Latência",
          ticket: "Ticket",
          httpStatus: "HTTP",
          input: "Entrada (Input)",
          output: "Saída (Output)",
          error: "Erro",
          noLogs: "Nenhum log de execução encontrado.",
        },
        connectorHelp: {
          title: "Ajuda de Configuração",
          showHelp: "Ver documentação",
          hideHelp: "Ocultar documentação",
          viewFullDocs: "Ver documentação completa",
          authSection: "Autenticação",
          fieldsSection: "Campos",
          ixc: {
            title: "IXC Provedor (ERP)",
            description: "Integração com o sistema IXC Soft para provedores de internet.",
            requirements: "Requisitos",
            docUrl: "https://wikiapiprovedor.ixcsoft.com.br/",
            requirementsList: [
              "Token de API do IXC (Menu: Sistema → Usuários → Editar → Token API)",
              "URL do webservice (ex: https://seudominio.com.br/webservice/v1)",
              "Permissões de leitura/escrita no módulo su_ticket",
            ],
            authHelp: "Use autenticação Basic Auth com o token no formato 'ID:TOKEN'",
            fieldsHelp: "Campos obrigatórios: id_ticket_setor, titulo, menssagem",
            example: "Exemplo de uso: Abrir chamado técnico para cliente",
          },
          milvus: {
            title: "Milvus Help Desk",
            description: "Integração com o sistema Milvus para gestão de chamados de suporte.",
            requirements: "Requisitos",
            docUrl: "https://developers.milvus.com.br/",
            requirementsList: [
              "Token de API do Milvus (Configurações → Integrações → API)",
              "URL da API (ex: https://api.milvus.com.br/v1)",
              "Chave de organização (org_id)",
            ],
            authHelp: "Use Bearer Token com o token de API gerado no painel Milvus",
            fieldsHelp: "Campos obrigatórios: titulo, descricao, categoria_id",
            example: "Exemplo de uso: Criar e consultar chamados de suporte",
          },
          zendesk: {
            title: "Zendesk Support",
            description: "Integração com o Zendesk para gestão de tickets de suporte.",
            requirements: "Requisitos",
            docUrl: "https://developer.zendesk.com/api-reference/",
            requirementsList: [
              "Subdomínio Zendesk (ex: suaempresa.zendesk.com)",
              "Email do agente + Token API",
              "Configurar em: Admin → Canais → API",
            ],
            authHelp: "Use Basic Auth com email/token ou Bearer Token",
            fieldsHelp: "Campos obrigatórios: subject, description, requester",
            example: "Exemplo de uso: Criar e gerenciar tickets de suporte",
          },
          triatox: {
            title: "Triatox Laboratório",
            description: "Integração com o sistema Triatox para laboratórios.",
            requirements: "Requisitos",
            requirementsList: [
              "Credenciais de API fornecidas pelo Triatox",
              "URL do endpoint de produção",
              "Certificado de acesso (se aplicável)",
            ],
            authHelp: "Use as credenciais fornecidas pelo suporte Triatox",
            fieldsHelp: "Consulte a documentação específica do Triatox",
            example: "Exemplo de uso: Consultar resultados de exames",
          },
          generic: {
            title: "API REST Genérica",
            description: "Configure qualquer API REST. Ideal para integrações customizadas.",
            requirements: "Requisitos",
            requirementsList: [
              "URL base da API (ex: https://api.exemplo.com)",
              "Documentação da API com endpoints disponíveis",
              "Credenciais de autenticação (se necessário)",
            ],
            authHelp: "Escolha o tipo de autenticação: Bearer, Basic, API Key ou Header customizado",
            fieldsHelp: "Configure os parâmetros conforme a documentação da API",
            example: "Exemplo de uso: Integrar com qualquer sistema via API REST",
          },
          custom: {
            title: "Configuração Manual",
            description: "Configure todos os detalhes manualmente, sem template pré-definido.",
            requirements: "Requisitos",
            requirementsList: [
              "Conhecimento técnico da API a ser integrada",
              "Documentação completa da API",
              "Credenciais e endpoints",
            ],
            authHelp: "Configure a autenticação conforme a documentação da API",
            fieldsHelp: "Defina todos os parâmetros necessários manualmente",
            example: "Para integrações que não se encaixam nos conectores pré-definidos",
          },
        },
        responsePresets: {
          title: "Presets de Mapeamento",
          description: "Selecione um preset ou configure manualmente",
          custom: "Personalizado",
          standard: "Padrão ($.data.id)",
          ixcTicket: "IXC - Chamado ($.id)",
          milvusTicket: "Milvus - Chamado ($.chamado.id)",
          zendeskTicket: "Zendesk - Ticket ($.ticket.id)",
          restApi: "REST API ($.result)",
        },
        quickSetup: {
          title: "Configuração Rápida",
          credentialsStep: "Credenciais",
          autoConfigured: "✨ Configuração automática! O endpoint, parâmetros e mapeamentos já foram preenchidos. Você só precisa informar suas credenciais.",
          action: "Ação",
          endpoint: "Endpoint",
          parameters: "Parâmetros da IA",
          moreParams: "mais",
          credentials: "Suas Credenciais",
          urlHelp: "URL base da API (já preenchido, altere apenas se necessário)",
          tokenLabel: "Token de API / Chave de Acesso",
          tokenPlaceholder: "Cole seu token de API aqui",
          tokenHelp: "Token de autenticação obtido no painel do sistema",
          advancedSettings: "Configurações Avançadas",
        },
        transferTargets: {
          title: "Filas de destino",
          help: "A IA escolhe um destes destinos pelo nome. Descreva quando usar cada um; o texto vai para as instruções da ferramenta.",
          queue: "Fila",
          label: "Nome para a IA",
          labelHelp: "Vazio = nome da fila. Use o mesmo nome do seu prompt (ex.: Resultado de Exames).",
          whenToUse: "Quando usar",
          whenToUsePlaceholder: "Ex.: paciente quer enviar resultados de exames",
          add: "Adicionar fila",
          remove: "Remover",
          required: "Escolha ao menos uma fila de destino.",
          queueRequired: "Escolha a fila",
          labelDuplicate: "Nome repetido",
          labelTooLong: "Nome para a IA passa de 60 caracteres",
          whenToUseTooLong: "Quando usar passa de 200 caracteres",
          queueMissing: "Fila não existe mais",
        },
      },
      contactModal: {
        title: {
          add: "Adicionar contato",
          edit: "Editar contato",
        },
        form: {
          mainInfo: "Dados do contato",
          extraInfo: "Informações adicionais",
          name: "Nome",
          number: "Número do Whatsapp",
          email: "Email",
          extraName: "Nome do campo",
          extraValue: "Valor",
          chatBotContact: "Desabilitar chatbot",
          termsLGDP: "Termos LGPD aceito em:",
          whatsapp: "Conexão Origem: ",
        },
        errors: {
          numberWithDDI:
            "Informe o número com DDI. Para Brasil use 55 (ex.: 5511999999999) ou substitua pelo código do país (ex.: +12125551234)",
        },
        buttons: {
          addExtraInfo: "Adicionar informação",
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Contato salvo com sucesso.",
      },
      queueModal: {
        title: {
          queueData: "Dados da fila",
          text: "Horários de atendimento",
          add: "Adicionar fila",
          edit: "Editar fila",
          confirmationDelete:
            "Tem certeza? Todas as opções de integrações serão deletadas.",
        },
        form: {
          name: "Nome",
          color: "Cor",
          orderQueue: "Ordem da fila (Bot)",
          rotate: "Rodízio",
          timeRotate: "Tempo de Rodízio",
          distributionStrategy: {
            label: "Estratégia de distribuição",
            random: "Distribuição aleatória",
            round_robin: "Rodízio sequencial",
            least_load: "Menor carga",
          },
          rotateHelp: {
            title: "Como funciona o Rodízio",
            content: "Quando ativado, o sistema escolhe um atendente online e sem pausa para cada ticket novo. Aleatória sorteia; Rodízio sequencial passa um por vez, aproximadamente na mesma ordem; Menor carga escolhe quem tem menos atendimentos abertos e aguardando. O ticket continua em Aguardando até o atendente aceitar. O tempo define em quanto tempo um ticket não aceito passa para outro atendente. O limite de atendimentos de cada pessoa fica no cadastro do usuário.",
          },
          greetingMessage: "Mensagem de saudação",
          complationMessage: "Mensagem de conclusão",
          outOfHoursMessage: "Mensagem de fora de expediente",
          token: "Token",
          none: "Nenhum",
          integrationId: "Integração",
          flowId: "FlowBuilder",
          flowPriorityHelp: "FlowBuilder e Integração são exclusivos: configure apenas um deles na fila. Para trocar, remova o que está selecionado primeiro.",
          flowIntegrationConflict: "Não é possível salvar a fila com FlowBuilder e Integração ao mesmo tempo. Remova um dos dois.",
          fileListId: "Lista de arquivos",
          closeTicket: "Encerrar Atendimento",
          queueType: "Tipo de menu",
          message: "Mensagem de retorno",
          queue: "Fila para transferência",
          integration: "Integração",
          file: "Lista de arquivos",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        bot: {
          title: "Opções",
          toolTipTitle: "Adicione opções para construir um chatbot",
          toolTip:
            "Se houver apenas uma opção, ela será escolhida automaticamente, fazendo com que o bot responda com a mensagem da opção e siga adiante",
          selectOption: "Selecione uma opção",
          text: "Texto",
          attendent: "Atendente",
          queue: "Fila",
          integration: "Integração",
          file: "Arquivo",
          toolTipMessageTitle:
            "A mensagem é obrigatória para seguir ao próximo nível",
          toolTipMessageContent:
            "A mensagem é obrigatória para seguir ao próximo nível",
          selectUser: "Selecione um Usuário",
          selectQueue: "Selecione uma Fila",
          selectIntegration: "Selecione uma Integração",
          addOptions: "Adicionar opções",
        },
        schedules: {
          showButton: "Configurar Horários de Expediente",
        },
        serviceHours: {
          dayWeek: "Dia da semana",
          startTimeA: "Início - Turno A",
          endTimeA: "Final - Turno A",
          startTimeB: "início - Turno B",
          endTimeB: "Final - Turno B",
          monday: "Segunda-feira",
          tuesday: "Terça-feira",
          wednesday: "Quarta-feira",
          thursday: "Quinta-feira",
          friday: "Sexta-feira",
          saturday: "Sábado",
          sunday: "Domingo",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Adicionar projeto",
          edit: "Editar projeto",
        },
        form: {
          id: "ID",
          type: "Tipo",
          name: "Nome",
          projectName: "Nome do Projeto",
          language: "Linguagem",
          jsonContent: "JsonContent",
          urlN8N: "URL",
          typebotSettings: "Configurações do Typebot",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tempo em minutos para expirar uma conversa",
          typebotKeywordFinish: "Palavra para finalizar o ticket",
          typebotKeywordRestart: "Palavra para reiniciar o fluxo",
          typebotRestartMessage: "Mensagem ao reiniciar a conversa",
          typebotUnknownMessage: "Mensagem de opção inválida",
          typebotDelayMessage: "Intervalo (ms) entre mensagens",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          test: "Testar Bot",
        },
        messages: {
          testSuccess: "Integração testada com sucesso!",
          addSuccess: "Integração adicionada com sucesso.",
          editSuccess: "Integração editada com sucesso.",
        },
      },
      userModal: {
        warning:
          "Para fazer a importação das mensagens é necessário ler o qrCode novamente !!!",
        title: {
          add: "Adicionar usuário",
          edit: "Editar usuário",
          updateImage: "Atualizar imagem",
          removeImage: "Excluir imagem",
          editImage: "Editar imagem",
          addImage: "Adicionar imagem",
        },
        form: {
          name: "Nome",
          signatureName: "Nome para assinatura",
          signatureNameHelper:
            "Nome exibido na assinatura das mensagens. Vazio = usa o nome completo.",
          email: "Email",
          password: "Senha",
          farewellMessage: "Mensagem de despedida",
          profile: "Perfil",
          startWork: "Início de trabalho",
          endWork: "Fim de trabalho",
          whatsapp: "Conexão Padrão",
          allTicketEnable: "Habilitado",
          allTicketDisable: "Desabilitado",
          allTicket: "Visualizar chamados sem fila",
          allowGroup: "Permitir Grupos",
          maxConcurrentTickets: "Máximo de atendimentos simultâneos",
          maxConcurrentTicketsHelp: "Vale para o rodízio das filas: soma atendimentos abertos e aguardando em todas as filas. Vazio ou 0 = sem limite.",
          maxConcurrentTicketsInvalid: "Informe um número inteiro de 0 a 1000.",
          seeAllGroups: "Ver todos os grupos",
          seeAllGroupsHelp: "Ligado: vê todos os grupos das conexões que alcança, inclusive os que surgirem depois.",
          groupAccess: "Grupos que este usuário vê",
          groupAccessPlaceholder: "Buscar grupo",
          groupAccessEmpty: "Nenhum grupo marcado: este usuário não verá grupos.",
          groupAccessHidden: "{{count}} grupo(s) de conexões fora do alcance atual continuam salvos.",
          allHistoric: "Ver conversas de outras filas",
          allHistoricEnabled: "Habilitado",
          allHistoricDisabled: "Desabilitado",
          allUserChat: "Ver conversas de outros usuários",
          userClosePendingTicket: "Permitir fechar tickets pendentes",
          showDashboard: "Ver Dashboard",
          allowRealTime: "Ver Painel de Atendimentos",
          allowConnections: "Permitir ações nas conexões",
        },
        settings: {
          personal: "Configurações Pessoais",
          general: "Configurações Gerais",
        },
        tabs: {
          general: "Geral",
          permissions: "Permissões",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          addImage: "Adicionar Imagem",
          editImage: "Editar Imagem",
        },
        success: "Usuário salvo com sucesso.",
        avatarModal: {
          title: "Editar foto de perfil",
          current: "Imagem atual",
          preview: "Nova imagem",
          dropHere: "Solte a imagem aqui",
          dropzoneText:
            "Arraste e solte uma imagem aqui, ou clique para selecionar",
          hint: "Para melhores resultados, utilize uma imagem quadrada",
          remove: "Remover foto",
          cancel: "Cancelar",
          save: "Salvar",
          changePhoto: "Alterar foto",
          uploadPhoto: "Enviar foto",
          imageDeleted: "Imagem removida!",
        },
      },
      companyModal: {
        title: {
          add: "Adicionar empresa",
          edit: "Editar empresa",
        },
        form: {
          name: "Nome",
          email: "Email",
          passwordDefault: "Senha",
          numberAttendants: "Usuários",
          numberConections: "Conexões",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Empresa salvo com sucesso.",
      },
      scheduleModal: {
        title: {
          add: "Novo Agendamento",
          edit: "Editar Agendamento",
          error: "Erro de Envio",
        },
        form: {
          body: "Mensagem",
          contact: "Contato",
          sendAt: "Data de Agendamento",
          sentAt: "Data de Envio",
          assinar: "Enviar Assinatura",
          whatsapp: "Conexão",
          openTicket: "Abrir Ticket",
          enabledOpenTicket: "Habilitado",
          disabledOpenTicket: "Desabilitado",
          selectUser: "Usuário",
          selectQueue: "Fila",
          statusTicket: "Status do Ticket",
          closedTicketStatus: "Fechado",
          openTicketStatus: "Aberto",
          pendingTicketStatus: "Pendente",
          interval: "Intervalo",
          intervalValue: "Valor do Intervalo",
          sendTimes: "Enviar quantas vezes",
          sendType: "Tipo de Envio",
          sendNormally: "Enviar normalmente em dias não úteis",
          sendBeforeWorkday: "Enviar um dia útil antes",
          sendAfterWorkday: "Enviar um dia útil depois",
          days: "Dias",
          weeks: "Semanas",
          months: "Meses",
          minutes: "Minutos",
        },
        fileExceedsQuota: "O tamanho do arquivo excede o espaço disponível.",
        quotaExceededDropzone:
          "Quota de armazenamento excedida. Não é possível adicionar arquivos.",
        sections: {
          message: "Informações da Mensagem",
          settings: "Configurações de Envio",
          templateWaba: "Template WABA",
          recurrence: "Recorrência",
          recurrenceDescription:
            "Defina se a mensagem vai se repetir e o que fazer quando cair no fim de semana.",
        },
        templateWaba: {
          description:
            "Selecione um template aprovado para envio oficial via WABA (opcional).",
          templateLabel: "Template WABA",
          none: "Nenhum",
          helper: "Templates disponíveis para a conexão WABA selecionada.",
          loading: "Carregando templates...",
          language: "Idioma",
          parametersTitle: "Variáveis do template",
          parameterLabel: "Variável",
          parameterHelper: "Informe o valor que será enviado no template.",
          noParameters: "Este template não possui variáveis.",
          unsupportedHeaderMedia:
            "Este template usa mídia no header e não é suportado no agendamento.",
          unsupportedButtons:
            "Este template possui variáveis em botões e não é suportado no agendamento.",
          missingParameters:
            "Preencha todas as variáveis do template antes de salvar.",
          attachmentsBlocked: "Anexos não são usados com template WABA.",
          attachmentsBlockedHint:
            "Anexos não são usados quando um template WABA está selecionado.",
        },
        helper: {
          interval:
            "Escolha a unidade: dias, semanas, meses ou minutos.",
          intervalValue:
            "0 = sem repetição. 1+ = repetir.",
          sendTimes:
            "0 = só o envio atual. 1+ = repetições adicionais.",
          dayType:
            "Se cair em fim de semana, antecipa ou posterga.",
        },
        helpModal: {
          title: "Ajuda de Recorrência",
          intro:
            "Use a recorrência para repetir o envio automaticamente após a data inicial.",
          examplesTitle: "Exemplos reais",
          examples:
            "Toda semana: Intervalo = Semanas, Valor = 1, Enviar = 4 (envio agora + 4 semanas).\nTodo mês: Intervalo = Meses, Valor = 1, Enviar = 2 (envio agora + 2 meses).\nA cada 10 dias: Intervalo = Dias, Valor = 10, Enviar = 3 (envio agora + 3 repetições).\nFim de semana: Tipo de Envio = \"um dia útil depois\" (cai sábado, envia na segunda).",
          tips:
            "Dica: Valor 0 não repete. \"Enviar quantas vezes\" é o número de repetições adicionais. Se cair no fim de semana, escolha antecipar ou postergar.",
          close: "Fechar",
          aria: "Abrir ajuda de recorrência",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          close: "Fechar",
          addSchedule: "Adicionar agendamento",
          attach: "Anexar Arquivo",
        },
        success: "Agendamento salvo com sucesso.",
        confirmationModal: {
          deleteTitle: "Deletar Anexo?",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida!",
        },
        toasts: {
          deleted: "Anexo removido com sucesso.",
        },
        tabs: {
          message: "Mensagem",
          settings: "Configurações",
        },
        dropzoneText:
          "Arraste e solte um arquivo aqui, ou clique para selecionar",
        readOnlyAttachments:
          "Este agendamento já foi enviado. Nenhuma alteração é permitida.",
      },
      pauseModal: {
        title: "Modo Pausa",
        subtitle: "Selecione a duração da sua pausa",
        confirm: "Ativar Pausa",
        cancel: "Cancelar",
        options: {
          quick: {
            label: "15 min",
            description: "Pausa rápida",
          },
          coffee: {
            label: "30 min",
            description: "Café / intervalo",
          },
          lunch: {
            label: "1h30",
            description: "Almoço",
          },
          manual: {
            label: "Manual",
            description: "Defina o tempo",
          },
        },
        customTime: {
          title: "Defina a duração",
          hours: "horas",
          minutes: "minutos",
          totalLabel: "Total",
          selectDuration: "Selecione a duração",
        },
      },
      tagModal: {
        title: {
          add: "Nova Tag",
          edit: "Editar Tag",
          addKanban: "Nova Lane",
          editKanban: "Editar Lane",
        },
        form: {
          name: "Nome",
          color: "Cor",
          timeLane: "Redirecionar em (Horas)",
          nextLaneId: "Lane",
          greetingMessageLane: "Mensagem de saudação da lane",
          rollbackLaneId: "Voltar após retomar atendimento",
          kanbanSettings: "Configurações da Lane",
          semanticTitle: "Categorização automática (IA)",
          semanticDescription: "Descrição semântica",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Tag salva com sucesso.",
        successKanban: "Lane salva com sucesso.",
        contacts: "Contatos",
        noContactsMessage: "Nenhum contato vinculado a esta tag.",
      },
      fileModal: {
        title: {
          add: "Adicionar lista de arquivos",
          edit: "Editar lista de arquivos",
        },
        buttons: {
          okAdd: "Salvar",
          okEdit: "Editar",
          cancel: "Cancelar",
          fileOptions: "Adicionar arquivo",
        },
        form: {
          name: "Nome da lista de arquivos",
          message: "Detalhes da lista",
          fileOptions: "Lista de arquivos",
          extraName: "Mensagem para enviar com arquivo",
          extraValue: "Valor da opção",
        },
        success: "Lista de arquivos salva com sucesso!",
      },
      chat: {
        noTicketMessage: "Selecione um ticket para começar a conversar.",
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop:
            "⬇️ ARRASTE E SOLTE ARQUIVOS NO CAMPO ABAIXO ⬇️",
          titleFileList: "Lista de arquivo(s)",
        },
      },
      chatInternal: {
        title: "Chat Interno",
        new: "Novo",
        selectChat: "Selecione um chat para começar",
        emptyState: "Selecione uma conversa para começar",
        buttons: {
          new: "Novo",
        },
        participants: "participante",
        participantsPlural: "participantes",
        messagePlaceholder: "Digite uma mensagem...",
        privateMessagePlaceholder: "Mensagem privada para",
        modal: {
          conversation: "Início",
          title: "Título",
          createTitle: "Criar Nova Sala",
          editTitle: "Editar Sala",
          iconColor: "Cor do Ícone",
          filterUsers: "Selecionar Usuários",
          cancel: "Cancelar",
          save: "Salvar",
        },
        modalDelete: {
          title: "Excluir Chat",
          message: "Esta ação não pode ser revertida, confirmar?",
        },
        options: {
          sticker: "Figurinha",
          voiceMessage: "Mensagem de voz",
          poll: "Enquete",
          location: "Localidade",
        },
        privateMessage: {
          sendPrivate: "Enviar mensagem privada",
          privateFor: "Mensagem privada para",
          badge: "Privada",
          for: "para",
        },
        messages: {
          deleted: "Mensagem apagada",
          deletedVisible: "Apagada",
          edited: "editada",
        },
        contextMenu: {
          reply: "Responder",
          react: "Reagir",
          edit: "Editar",
          delete: "Apagar",
        },
        editDialog: {
          title: "Editar Mensagem",
          placeholder: "Digite a nova mensagem...",
          original: "Original",
          cancel: "Cancelar",
          save: "Salvar",
        },
      },
      ticketsManager: {
        questionCloseTicket: "VOCÊ DESEJA FECHAR TODOS OS TICKETS?",
        yes: "SIM",
        not: "NÃO",
        buttons: {
          newTicket: "Novo",
          resolveAll: "Resolver Todos",
          close: "Fechar",
          new: "Novo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Filas",
      },
      tickets: {
        showAll: {
          lockedByTeam: "Ativo por participação em equipe — tickets de colegas precisam estar visíveis para notificações de equipe",
        },
        inbox: {
          closedAllTickets: "Fechar todos os tickets?",
          closedAll: "Fechar Todos",
          newTicket: "Novo Ticket",
          yes: "SIM",
          no: "NÃO",
          open: "Abertos",
          resolverd: "Resolvidos",
        },
        toasts: {
          deleted: "O atendimento que você estava foi deletado.",
          redirectedToExisting: "Já existe um atendimento aberto para este contato. Você foi redirecionado.",
        },
        notification: {
          message: "Mensagem de",
        },
        tabs: {
          open: { title: "Abertas" },
          closed: { title: "Resolvidos" },
          search: { title: "Busca" },
        },
        search: {
          placeholder: "Buscar Tickets e Mensagens",
          filterConections: "Filtro por Conexão",
          filterConectionsOptions: {
            open: "Aberto",
            closed: "Fechado",
            pending: "Pendente",
          },
          filterUsers: "Selecionar Usuários",
          filterContacts: "Filtro por Contatos",
          ticketsPerPage: "Tickets por página",
        },
        buttons: {
          showAll: "Todos",
          returnQueue: "Devolver a Fila",
          scredule: "Agendamento",
          deleteTicket: "Deletar Ticket",
        },
        closedTicket: {
          closedMessage: "Fechar Ticket Com Mensagem de Despedida",
          closedNotMessage: "Fechar Ticket Sem Mensagem de Despedida",
        },
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Digite para buscar atendente",
        fieldQueueLabel: "Transferir para fila",
        fieldQueuePlaceholder: "Selecione uma fila",
        fieldWhatsapp: "Selecione um whatsapp",
        noOptions: "Nenhum usuário encontrado com esse nome",
        msgTransfer: "Observações - mensagem interna, não vai para o cliente",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        called: "Chamado",
        today: "Hoje",
        missedCall: "Chamada de voz/vídeo perdida às",
        pendingHeader: "Aguardando",
        assignedHeader: "Atendendo",
        groupingHeader: "Grupos",
        noTicketsTitle: "Nada aqui!",
        noTicketsMessage:
          "Nenhum atendimento encontrado com esse status ou termo pesquisado",
        noQueue: "Sem Fila",
        noQueueBadge: "{{count}} sem fila",
        noQueueTooltip: "Tickets aguardando sem nenhuma fila. Ninguém da equipe os vê. Configure uma fila de redirecionamento na conexão ou assuma manualmente.",
        noQueueFilterOn: "Mostrando só tickets sem fila — clique para ver todos",
        noLastMessage: "Sem preview",
        buttons: {
          accept: "Aceitar",
          cancel: "Cancelar",
          start: "iniciar",
          closed: "Fechar",
          reopen: "Reabrir",
          transfer: "Transferir",
          ignore: "Ignorar",
          exportAsPDF: "Exportar para PDF",
          kanbanActions: "Opções de Kanban",
        },
        acceptModal: {
          title: "Aceitar Chat",
          queue: "Selecionar setor",
        },
      },
      newTicketModal: {
        title: "Criar Ticket",
        fieldLabel: "Digite para pesquisar o contato",
        add: "Adicionar",
        buttons: {
          ok: "Salvar",
          start: "Iniciar",
          cancel: "Cancelar",
        },
      },
      SendContactModal: {
        title: "Enviar contato",
        fieldLabel: "Digite para pesquisar o contato",
        add: "Adicionar",
        buttons: {
          ok: "Enviar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexões",
          chatsTempoReal: "Painel",
          tickets: "Atendimentos",
          quickMessages: "Respostas rápidas",
          contacts: "Contatos",
          queues: "Filas & Setores",
          tags: "Tags",
          administration: "Administração",
          companies: "Empresas",
          users: "Usuários",
          settings: "Configurações",
          profilePermissions: "Permissões de Perfil",
          files: "Lista de arquivos",
          helps: "Ajuda",
          tasks: "Tarefas",
          leads: "Leads",
          automations: "Automações",
          journey: "Jornada",
          messagesAPI: "API",
          publicApi: "API Pública v1",
          voiceApi: "Voice AI API",
          schedules: "Agendamentos",
          callbacks: "Callbacks",
          campaigns: "Campanhas",
          annoucements: "Informativos",
          chats: "Chat Interno",
          financeiro: "Financeiro",
          queueIntegration: "Integrações",
          version: "Versão",
          kanban: "Kanban",
          prompts: "Talk.Ai",
          aiConfigurations: "Configurações de IA",
          aiTools: "Integrações IA",
          allConnections: "Gerenciar conexões",
          reportsAdvanced: "Relatórios Avançados",
          reports: "Relatórios",
          management: "Gestão",
          whatsappGroups: "Grupos WhatsApp",
          moments: "Moments",
          stalledTickets: "Atendimentos parados",
          whatsappCommunities: "Comunidades",
          whatsappFlows: "WhatsApp Flows",
          email: "E-mail",
          contactsImport: "Importar contatos",
          helpCenter: "Central de Ajuda",
          internalChat: "Chat interno",
          todo: "To-do",
          tagsKanban: "Colunas do Kanban",
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Sair",
            message: "Olá",
            messageEnd: "seja bem-vindo a",
            active: "Ativo até",
            goodMorning: "Oi,",
            myName: "meu nome é",
            continuity: "e darei continuidade em seu atendimento.",
            virtualAssistant: "Assistente Virtual",
            token:
              "Token inválido, por favor entre em contato com o administrador da plataforma.",
          },
          message: {
            location: "Localização",
            contact: "Contato",
          },
          theme: {
            dark: "Modo Escuro",
            light: "Modo Claro",
          },
          notRegister: "Nenhum registro",
          refresh: "Atualizar",
        },
      },
      languages: {
        undefined: "Idioma",
        "pt-BR": "Português",
        es: "Español",
        en: "English",
        tr: "Türkçe",
      },
      apiV1Settings: {
        title: "API Pública v1",
      },
      messagesAPI: {
        title: "API",
        textMessage: {
          number: "Número",
          body: "Mensagem",
          token: "Token cadastrado",
          userId: "ID do usuário/atendente",
          queueId: "ID da Fila",
        },
        mediaMessage: {
          number: "Número",
          body: "Nome do arquivo",
          media: "Arquivo",
          token: "Token cadastrado",
        },
        API: {
          title: "Documentação para envio de mensagens",
          methods: {
            title: "Métodos de Envio",
            messagesText: "Mensagens de Texto",
            messagesMidia: "Mensagens de Mídia",
          },
          instructions: {
            title: "Instruções",
            comments: "Observações Importantes",
            comments1:
              "Antes de enviar mensagens, é necessário o cadastro do token vinculado à conexão que enviará as mensagens. Para realizar o cadastro acesse o menu 'Conexões', clique no botão editar da conexão e insira o token no devido campo.",
            comments2:
              "O número para envio não deve ter máscara ou caracteres especiais e deve ser composto por:",
            codeCountry: "Código do País",
            code: "DDD",
            number: "Número",
          },
          text: {
            title: "1. Mensagens de Texto",
            instructions:
              "Seguem abaixo a lista de informações necessárias para envio das mensagens de texto:",
          },
          media: {
            title: "2. Mensagens de Mídia",
            instructions:
              "Seguem abaixo a lista de informações necessárias para envio das mensagens de texto:",
          },
        },
      },
      notifications: {
        title: "Notificações",
        noTickets: "Nenhuma notificação.",
      },
      quickMessages: {
        title: "Respostas Rápidas",
        searchPlaceholder: "Pesquisar...",
        dropzoneText:
          "Arraste e solte um arquivo aqui, ou clique para selecionar",
        viewAttachment: "Ver Anexo",
        noAttachment: "Sem anexo",
        preview: {
          title: "Visualização do Anexo",
          close: "Fechar",
        },
        fileExceedsQuota: "O tamanho do arquivo excede o espaço disponível.",
        quotaExceededDropzone:
          "Quota de armazenamento excedida. Não é possível adicionar arquivos.",
        confirmationModal: {
          deleteTitle: "Exclusão",
          deleteMessage: "Esta ação é irreversível! Deseja prosseguir?",
        },
        buttons: {
          add: "Adicionar",
          attach: "Anexar Arquivo",
          cancel: "Cancelar",
          edit: "Editar",
        },
        toasts: {
          success: "Atalho adicionado com sucesso!",
          deleted: "Atalho removido com sucesso!",
        },
        dialog: {
          title: "Mensagem Rápida",
          info: "Mensagens Rápidas",
          shortcode: "Atalho",
          message: "Resposta",
          save: "Salvar",
          cancel: "Cancelar",
          geral: "Permitir que outros editem",
          add: "Adicionar",
          edit: "Editar",
          visao: "Visibilidade",
          attachment: "Anexo",
        },
        table: {
          shortcode: "Atalho",
          message: "Mensagem",
          actions: "Ações",
          mediaName: "Nome do Arquivo",
          status: "Status",
        },
      },
      contactLists: {
        title: "Listas de Contatos",
        table: {
          name: "Nome",
          contacts: "Contatos",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Lista",
        },
        dialog: {
          name: "Nome",
          company: "Empresa",
          okEdit: "Editar",
          okAdd: "Adicionar",
          add: "Adicionar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },
      contactListItems: {
        title: "Contatos",
        searchPlaceholder: "Pesquisa",
        buttons: {
          add: "Novo",
          lists: "Listas",
          import: "Importar",
        },
        dialog: {
          name: "Nome",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "E-mail",
          okEdit: "Editar",
          okAdd: "Adicionar",
          add: "Adicionar",
          edit: "Editar",
          cancel: "Cancelar",
        },
        table: {
          name: "Nome",
          number: "Número",
          whatsapp: "Whatsapp",
          email: "E-mail",
          actions: "Ações",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
          importMessage: "Deseja importar os contatos desta planilha? ",
          importTitlte: "Importar",
        },
        toasts: {
          deleted: "Registro excluído",
        },
      },

      kanban: {
        title: "Kanban",
        searchPlaceholder: "Pesquisa",
        subMenus: {
          list: "Painel",
          tags: "Lanes",
        },
        modeToggle: {
          label: "Modo",
          company: "Empresa",
          personal: "Pessoal",
          companyTooltip: "Ver Kanban padrão da empresa",
          personalTooltip: "Ver seu Kanban personalizado",
        },
        laneEditor: {
          createLane: "Nova Lane",
          editLane: "Editar Lane",
          viewInheritedLane: "Visualizar Lane Herdada",
          name: "Nome",
          color: "Cor",
          hidden: "Ocultar lane",
          automation: "Configurações da Lane",
          timeLane: "Redirecionar em (Horas)*",
          timeLaneHelp: "Tempo em horas para mover automaticamente (ex: 24 = 1 dia) - Obrigatório quando próxima lane está definida",
          nextLane: "Lane",
          nextLaneHelp: "Lane para onde o ticket será movido automaticamente após o tempo configurado",
          rollbackLane: "Voltar após retomar atendimento",
          rollbackLaneHelp: "Lane para onde o ticket retorna quando o cliente responder",
          none: "Nenhuma",
          messaging: "Mensagens",
          greetingMessage: "Mensagem de saudação da lane",
          greetingMessageHelp: "Mensagem enviada quando ticket chegar nesta lane. Variáveis disponíveis: {{name}}, {{protocol}}, {{ms}}",
          inheritedLaneInfo: "Esta lane é herdada da empresa. Você só pode ocultar/exibir.",
          cancel: "Cancelar",
          save: "Adicionar",
          wipLimit: "Limite de tickets (WIP)",
          wipLimitHelp: "Número máximo de tickets simultâneos nesta coluna. Deixe vazio para sem limite.",
        },
        truncation: {
          message: "Exibindo {shown} de {total} tickets. Reduza o período para ver todos.",
        },
        groupBy: {
          label: "Agrupar por",
          none: "Nenhum",
          user: "Atendente",
          queue: "Fila",
          source: "Origem",
        },
        aging: {
          recent: "Recente",
          daysInStage: "{days}d nesta etapa",
        },
        search: {
          placeholder: "Buscar tickets...",
          noResults: "Nenhum ticket encontrado",
        },
        keyboard: {
          title: "Atalhos de Teclado",
          refresh: "Atualizar dados",
          fullscreen: "Alternar tela cheia",
          help: "Abrir guia de ajuda",
          escape: "Sair da tela cheia",
          column: "Rolar até a coluna N",
        },
        adminSelector: {
          title: "Kanbans dos Usuários",
          searchPlaceholder: "Buscar usuário...",
          noUsers: "Nenhum usuário encontrado",
        },
        personalKanban: {
          addLane: "Adicionar Lane",
          editLane: "Editar",
          deleteLane: "Excluir",
          confirmDelete: "Tem certeza que deseja excluir esta lane?",
          inheritedBadge: "Herdada",
          personalBadge: "Pessoal",
        },
      },

      campaigns: {
        title: "Campanhas",
        searchPlaceholder: "Pesquisa",
        subMenus: {
          list: "Listagem",
          listContacts: "Lista de contatos",
          settings: "Configurações",
        },
        settings: {
          randomInterval: "Intervalo Randômico de Disparo",
          noBreak: "Sem Intervalo",
          intervalGapAfter: "Intervalo maior após",
          undefined: "Não definido",
          messages: "mensagens",
          laggerTriggerRange: "Intervalo de disparo maior",
          addVar: "Adicionar variável",
          save: "Salvar",
          close: "Fechar",
          add: "Adicionar",
          shortcut: "Atalho",
          content: "Conteúdo",
        },
        buttons: {
          add: "Nova Campanha",
          contactLists: "Listas de Contatos",
        },
        fileExceedsQuota: "O tamanho do arquivo excede o espaço disponível.",
        quotaExceededDropzone:
          "Quota de armazenamento excedida. Não é possível adicionar arquivos.",
        table: {
          name: "Nome",
          whatsapp: "Conexão",
          contactList: "Lista de Contatos",
          option: "Nenhuma",
          disabled: "Desabilitada",
          enabled: "Habilitada",
          status: "Status",
          scheduledAt: "Agendamento",
          completedAt: "Concluída",
          confirmation: "Confirmação",
          actions: "Ações",
        },
        dialog: {
          new: "Nova Campanha",
          update: "Editar Campanha",
          readonly: "Apenas Visualização",
          help: "Utilize variáveis como {nome}, {numero}, {email} ou defina variáveis personalizadas.",
          form: {
            name: "Nome",
            message1: "Mensagem 1",
            message2: "Mensagem 2",
            message3: "Mensagem 3",
            message4: "Mensagem 4",
            message5: "Mensagem 5",
            confirmationMessage1: "Mensagem de Confirmação 1",
            confirmationMessage2: "Mensagem de Confirmação 2",
            confirmationMessage3: "Mensagem de Confirmação 3",
            confirmationMessage4: "Mensagem de Confirmação 4",
            confirmationMessage5: "Mensagem de Confirmação 5",
            messagePlaceholder: "Conteúdo da mensagem",
            whatsapp: "Conexão",
            status: "Status",
            scheduledAt: "Agendamento",
            confirmation: "Confirmação",
            contactList: "Lista de Contato",
            tagList: "Tags",
            statusTicket: "Status do Ticket",
            openTicketStatus: "Aberto",
            pendingTicketStatus: "Pendente",
            closedTicketStatus: "Fechado",
            enabledOpenTicket: "Habilitado",
            disabledOpenTicket: "Desabilitado",
            openTicket: "Abrir ticket",
            basic: "Informações Básicas",
            selection: "Seleção de Contatos",
            ticket: "Configurações de Ticket",
            messages: "Mensagens",
            config: "Configurações",
            confirmationTimeoutHours: "Timeout de confirmação (minutos)",
          },
          buttons: {
            add: "Adicionar",
            edit: "Atualizar",
            okadd: "Ok",
            cancel: "Cancelar Disparos",
            restart: "Reiniciar Disparos",
            close: "Fechar",
            attach: "Anexar Arquivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          success: "Operação realizada com sucesso",
          cancel: "Campanha cancelada",
          restart: "Campanha reiniciada",
          deleted: "Registro excluído",
          needWhatsapp:
            "É necessário selecionar uma conexão de WhatsApp para a campanha",
        },
        // Campanhas Recorrentes
        recurrence: {
          title: "Campanha Recorrente",
          type: "Frequência",
          monthly: "Mensal",
          weekly: "Semanal",
          daily: "Diária",
          dayOfMonth: "Dia do mês",
          dayOfWeek: "Dia da semana",
          sunday: "Domingo",
          monday: "Segunda-feira",
          tuesday: "Terça-feira",
          wednesday: "Quarta-feira",
          thursday: "Quinta-feira",
          friday: "Sexta-feira",
          saturday: "Sábado",
          time: "Horário",
          timezone: "Fuso horário",
          startDate: "Data de início",
          endDate: "Data de fim (último envio)",
          nextExecutions: "Próximas execuções",
          advanced: "Opções avançadas",
          skipWeekends: "Pular finais de semana (adiar para segunda)",
          skipHolidays: "Pular feriados",
          notifyOnExecution: "Notificar após cada execução",
          notifyEmail: "Email para notificação",
          status: {
            active: "Ativa",
            paused: "Pausada",
            completed: "Concluída",
            cancelled: "Cancelada",
          },
          history: {
            title: "Histórico de Execuções",
            execution: "Execução",
            date: "Data",
            status: "Status",
            sent: "Enviados",
            failed: "Falhas",
            skipped: "Pulados",
            duration: "Duração",
          },
        },
        // Mapeamento de Variáveis
        variables: {
          title: "Mapeamento de Variáveis",
          description: "Configure quais dados da lista de contatos serão usados para preencher as variáveis do template.",
          selectTemplate: "Selecione um template para configurar as variáveis",
          column: "Coluna",
          notMapped: "Não mapeado",
          default: "Valor padrão",
          skipMissing: "Pular contatos com variáveis obrigatórias vazias",
          allMapped: "Todas as variáveis configuradas",
          someMissing: "Algumas variáveis não estão mapeadas",
          preview: "Preview da mensagem",
          noPreview: "Configure o mapeamento para ver o preview",
        },
      },
      campaignReport: {
        title: "Relatório de",
        inactive: "Inativa",
        scheduled: "Programada",
        process: "Em Andamento",
        cancelled: "Cancelada",
        finished: "Finalizada",
        campaign: "Campanha",
        validContacts: "Contatos Válidos",
        confirmationsRequested: "Confirmações Solicitadas",
        confirmations: "Confirmações",
        deliver: "Entregues",
        connection: "Conexão",
        contactLists: "Lista de Contatos",
        schedule: "Agendamento",
        conclusion: "Conclusão",
      },
      announcements: {
        title: "Informativos",
        searchPlaceholder: "Pesquisa",
        active: "Ativo",
        inactive: "Inativo",
        notRegister: "Nenhum anúncio",
        fileExceedsQuota: "O tamanho do arquivo excede o espaço disponível.",
        quotaExceededDropzone:
          "Quota de armazenamento excedida. Não é possível adicionar arquivos.",
        buttons: {
          add: "Novo Informativo",
          contactLists: "Listas de Informativos",
          close: "Fechar",
        },
        table: {
          priority: "Prioridade",
          title: "Title",
          text: "Texto",
          mediaName: "Arquivo",
          status: "Status",
          actions: "Ações",
        },
        dialog: {
          edit: "Edição de Informativo",
          add: "Novo Informativo",
          update: "Editar Informativo",
          readonly: "Apenas Visualização",
          form: {
            priority: "Prioridade",
            title: "Title",
            text: "Texto",
            mediaPath: "Arquivo",
            status: "Status",
            high: "Alta",
            medium: "Média",
            low: "Baixa",
            active: "Ativo",
            inactive: "Inativo",
          },
          buttons: {
            add: "Adicionar",
            edit: "Atualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            close: "Fechar",
            attach: "Anexar Arquivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          success: "Operação realizada com sucesso",
          deleted: "Registro excluído",
        },
      },
      campaignsConfig: {
        title: "Configurações de Campanhas Não Oficial",
      },
      queues: {
        title: "Filas & Setores",
        table: {
          name: "Nome",
          color: "Cor",
          users: "Usuários",
          greeting: "Mensagem de saudação",
          orderQueue: "Ordenação da fila (bot)",
          actions: "Ações",
          ID: "ID",
        },
        buttons: {
          add: "Adicionar fila",
        },
        toasts: {
          success: "Fila salva com sucesso",
          deleted: "Fila excluída com sucesso",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Você tem certeza? Essa ação não pode ser revertida! Os atendimentos dessa fila continuarão existindo, mas não terão mais nenhuma fila atribuída.",
        },
      },
      queue: {
        queueData: "Dados",
      },
      teams: {
        title: "Equipes Colaborativas",
        description: "Equipes permitem notificar todos os membros quando um colega recebe novas mensagens. Colegas de equipe recebem som e alerta visual.",
        noTeams: "Nenhuma equipe criada nesta fila.",
        inactive: "Inativa",
        form: {
          addTitle: "Nova Equipe",
          editTitle: "Editar Equipe",
          name: "Nome da equipe",
          members: "Membros",
          selectMembers: "Selecione os membros...",
        },
        buttons: {
          newTeam: "Nova Equipe",
          add: "Criar",
          save: "Salvar",
          edit: "Editar",
          delete: "Excluir",
          cancel: "Cancelar",
        },
        toasts: {
          created: "Equipe criada com sucesso!",
          updated: "Equipe atualizada com sucesso!",
          deleted: "Equipe excluída com sucesso!",
        },
        confirmDelete: {
          title: "Excluir equipe",
          message: "Tem certeza que deseja excluir esta equipe? Os membros deixarão de receber notificações colaborativas.",
        },
        validation: {
          nameRequired: "Nome da equipe é obrigatório.",
          membersRequired: "Selecione pelo menos um membro para a equipe.",
        },
      },
      queueSelect: {
        inputLabel: "Filas",
        inputLabelRO: "Filas somente leitura",
        withoutQueue: "Sem fila",
      },
      reports: {
        title: "Relatórios de Atendimentos",
        table: {
          id: "Ticket",
          user: "Usuário",
          dateOpen: "Data Abertura",
          dateClose: "Data Fechamento",
          NPS: "NPS",
          status: "Status",
          whatsapp: "Conexão",
          queue: "Fila",
          actions: "Ações",
          lastMessage: "Últ. Mensagem",
          contact: "Cliente",
          supportTime: "Tempo de Atendimento",
        },
        buttons: {
          filter: "Filtrar",
          onlyRated: "Apenas Avaliados",
        },
        searchPlaceholder: "Pesquisar...",
        operator: "Operador",
        period: "Período",
        until: "Até",
        date: "Data",
        reportTitle: "Relatórios",
        calls: "Atendimentos",
        search: "Pesquisas",
        durationCalls: "Duracão dos atendimentos",
        grupoSessions: "Atendimentos em grupos",
        groupTicketsReports: {
          timezone: "America/Sao_Paulo",
          msgToast: "Gerando relatório compactado, por favor aguarde.",
          errorToast: "Erro ao gerar o relatório",
          back: "Voltar",
          groupServiceReport: "Relatório de Atendimento em Grupos",
          loading: "Carregando...",
          contact: "Contato",
          dateOpen: "Data abertura",
          dateLastUpdated: "Data Última Atualização",
          agent: "Quem atendeu",
          agentClosed: "Quem fechou",
          waitingAssistance: "Aguardando atendimento",
          process: "Em atendimento",
        },
        researchReports: {
          response: "resposta",
          active: "(Ativa)",
          inactive: "(Inativa)",
          quantity: "Quantidade",
          percentage: "porcentagem",
          title: "Relatório de Pesquisas Realizadas",
          activeSearch: "Pesquisa ativa",
          inactiveSearch: "Pesquisa inativa",
        },
        ticketDurationDetail: {
          msgToast: "Gerando relatório compactado, por favor aguarde.",
          title: "Relatório de Duração do Atendimento",
          startService: "Início do atendimento",
          lastUpdated: "Última atualização",
          lastAgent: "Último atendente",
          durationFinished: "Duração após finalizado",
        },
        ticketDuration: {
          title: "Relatório de Duração dos Atendimento",
          contact: "Contato",
          open: "Abertos",
          pending: "Pendentes",
          finished: "Finalizados",
          durationFinished: "Duração dos finalizados",
          durationAfterFinished: "Duração após finalizado",
          actions: "Ações",
        },
        ticketReports: {
          msgToast: "Gerando relatório compactado, por favor aguarde.",
          title: "Relatório de Atendimento",
        },
        pdf: {
          title: "Relação de Atendimentos Realizados",
          exportTitle: "Relação de Atendimentos em Grupos Realizados",
        },
      },
      reportsAdvanced: {
        title: "Relatórios Avançados",
        tabs: {
          productivity: "Produtividade",
          sla: "SLA",
          contacts: "Contatos",
          queues: "Filas",
          peakHours: "Horários de Pico",
          comparative: "Comparativo",
        },
        filters: {
          dateFrom: "Data Inicial",
          dateTo: "Data Final",
          users: "Usuários",
          queues: "Filas",
          tags: "Tags",
          channel: "Canal",
          apply: "Aplicar Filtros",
        },
        productivity: {
          title: "Relatório de Produtividade",
          topPerformer: "Melhor Performance",
          ticketsAttended: "Tickets Atendidos",
          avgFirstResponse: "Tempo Médio 1ª Resposta",
          avgResolution: "Tempo Médio Resolução",
          npsAverage: "NPS Médio",
          resolutionRate: "Taxa de Resolução",
          ranking: "Ranking de Atendentes",
        },
        sla: {
          title: "Relatório de SLA",
          firstResponseSLA: "SLA Primeira Resposta",
          resolutionSLA: "SLA Resolução",
          withinSLA: "Dentro do SLA",
          outsideSLA: "Fora do SLA",
          criticalTickets: "Tickets Críticos",
          byQueue: "Por Fila",
          configure: "Configurar SLA",
        },
        contacts: {
          title: "Relatório de Contatos",
          newContacts: "Novos Contatos",
          byChannel: "Por Canal",
          byTag: "Por Tag",
          topActive: "Mais Ativos",
          totalTickets: "Total de Tickets",
        },
        queues: {
          title: "Relatório de Filas",
          avgWaitTime: "Tempo Médio de Espera",
          avgResolutionTime: "Tempo Médio de Resolução",
          transfersIn: "Transferências Recebidas",
          transfersOut: "Transferências Enviadas",
          abandonRate: "Taxa de Abandono",
          peakHour: "Hora de Pico",
          transferMatrix: "Matriz de Transferências",
        },
        peakHours: {
          title: "Horários de Pico",
          heatmap: "Mapa de Calor",
          tickets: "tickets",
          byHour: "Por Hora",
          byDay: "Por Dia da Semana",
          days: {
            sun: "Dom",
            mon: "Seg",
            tue: "Ter",
            wed: "Qua",
            thu: "Qui",
            fri: "Sex",
            sat: "Sáb",
          },
        },
        comparative: {
          title: "Relatório Comparativo",
          currentPeriod: "Período Atual",
          previousPeriod: "Período Anterior",
          variation: "Variação",
          improvement: "melhoria",
          regression: "regressão",
          stable: "estável",
          insights: "Insights",
        },
        export: {
          title: "Exportar Relatório",
          csv: "Exportar CSV",
          pdf: "Exportar PDF",
          schedule: "Agendar Exportação",
          inProgress: "Exportação em andamento...",
          completed: "Exportação concluída!",
          download: "Baixar Arquivo",
        },
        schedule: {
          title: "Agendamentos de Relatórios",
          create: "Novo Agendamento",
          name: "Nome do Agendamento",
          frequency: "Frequência",
          daily: "Diário",
          weekly: "Semanal",
          monthly: "Mensal",
          recipients: "Destinatários",
          nextRun: "Próxima Execução",
          lastRun: "Última Execução",
          status: "Status",
          active: "Ativo",
          paused: "Pausado",
        },
        noData: "Nenhum dado encontrado para o período selecionado",
        loading: "Carregando dados...",
      },
      queueIntegration: {
        title: "Integrações",
        table: {
          id: "ID",
          type: "Tipo",
          name: "Nome",
          projectName: "Nome do Projeto",
          language: "Linguagem",
          lastUpdate: "Última atualização",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar Projeto",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Você tem certeza? Essa ação não pode ser revertida! e será removida das filas e conexões vinculadas",
        },
      },
      users: {
        title: "Usuários",
        table: {
          status: "Status",
          name: "Nome",
          email: "Email",
          profile: "Perfil",
          queues: "Filas",
          actions: "Ações",
          ID: "ID",
        },
        buttons: {
          add: "Adicionar usuário",
        },
        toasts: {
          deleted: "Usuário excluído com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todos os dados do usuário serão perdidos. Os atendimentos abertos deste usuário serão movidos para a fila.",
        },
      },
      compaies: {
        title: "Empresas",
        table: {
          list: "Lista",
          new: "Nova empresa",
          edit: "Editar empresa",
          cancel: "Cancelar",
          ID: "ID",
          status: "Ativo",
          name: "Nome",
          email: "Email",
          password: "Senha",
          phone: "Telefone",
          plan: "Plano",
          active: "Ativo",
          numberAttendants: "Atendentes",
          numberConections: "Conexões",
          value: "Valor",
          namePlan: "Nome Plano",
          numberQueues: "Filas",
          useCampaigns: "Campanhas",
          useExternalApi: "Rest API",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "Whatsapp",
          useInternalChat: "Chat Interno",
          useSchedules: "Agendamento",
          createdAt: "Criada Em",
          dueDate: "Vencimento",
          lastLogin: "Ult. Login",
          diskUsage: "Uso de Disco",
          actions: "Ações",
          money: "R$",
          yes: "Sim",
          no: "Não",
          document: "CNPJ/CPF",
          recurrence: "Recorrência",
          monthly: "Mensal",
          bimonthly: "Bimestral",
          quarterly: "Trimestral",
          semester: "Semestral",
          yearly: "Anual",
          clear: "Limpar",
          delete: "Excluir",
          user: "Usuário",
          save: "Salvar",
        },
        buttons: {
          add: "Adicionar empresa",
        },
        toasts: {
          deleted: "Empresa excluído com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todos os dados da empresa serão perdidos. Os tickets abertos deste usuário serão movidos para a fila.",
        },
      },
      plans: {
        form: {
          name: "Nome",
          users: "Usuários",
          connections: "Conexões",
          campaigns: "Campanhas",
          schedules: "Agendamentos",
          enabled: "Habilitadas",
          disabled: "Desabilitadas",
          clear: "Cancelar",
          delete: "Excluir",
          save: "Salvar",
          yes: "Sim",
          no: "Não",
          money: "R$",
          public: "Público",
          whatsappWuzapi: "WhatsApp (Wuzapi)",
          waba: "WhatsApp Business API (WABA)",
          webchat: "Webchat",
        },
      },
      helps: {
        title: "Central de Ajuda",
        new: "Nova Ajuda",
        edit: "Editar Ajuda",
        table: {
          ID: "ID",
          title: "Título",
          description: "Descrição",
          video: "Vídeo",
          actions: "Ações",
        },
        settings: {
          title: "Título",
          codeVideo: "Código do Vídeo",
          description: "Descrição",
          clear: "Limpar",
          delete: "Excluir",
          save: "Salvar",
        },
        buttons: {
          save: "Salvar",
          cancel: "Cancelar",
        },
      },
      helpCenter: {
        title: "Central de Ajuda",
        subtitle: "Encontre respostas para suas dúvidas e aprenda a usar todas as funcionalidades",
        searchPlaceholder: "Buscar na Central de Ajuda...",
        searchResults: "resultados encontrados",
        articles: "artigos",
        backToHome: "Central de Ajuda",
        comingSoon: "Conteúdo em preparação",
        comingSoonDesc: "Este artigo está sendo elaborado e será disponibilizado em breve.",
        relatedArticles: "Artigos Relacionados",
        scenarios: "Cenários Reais",
        faq: "Perguntas Frequentes",
        noResults: "Nenhum resultado encontrado",
        noResultsDesc: "Tente buscar com outros termos",
      },
      schedules: {
        title: "Agendamentos",
        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir este Agendamento?",
          deleteMessage: "Esta ação não pode ser revertida.",
          deleteSeriesTitle: "Cancelar a série inteira?",
          deleteSeriesMessage:
            "Isso cancela a série inteira ({{remaining}} envios pendentes para {{contact}}), não só este dia. Envios já feitos não são desfeitos.",
        },
        table: {
          contact: "Contato",
          body: "Mensagem",
          sendAt: "Data de Agendamento",
          sentAt: "Data de Envio",
          status: "Status",
          actions: "Ações",
        },
        buttons: {
          add: "Novo Agendamento",
        },
        toasts: {
          deleted: "Agendamento excluído com sucesso.",
        },
        calendar: {
          indicatorPending: "{{sent}}/{{total}} enviados · próximo {{next}}",
          indicatorDone: "{{sent}}/{{total}} enviados",
          indicatorError: "{{sent}}/{{total}} · falhou {{next}}",
          indicatorTruncated: "exibindo {{emitted}} de {{logicalTotal}}",
          loadMore: "Carregar mais",
          showingCount: "Mostrando {{loaded}} de {{total}}",
          emptyLoadedRange: "Nenhuma ocorrência das séries carregadas neste período.",
          partialRange: "Exibição parcial neste período — use a visão semanal ou diária para ver todas as ocorrências.",
        },
      },
      tags: {
        title: "Tags",
        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir esta Tag?",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        table: {
          id: "ID",
          name: "Nome",
          kanban: "Kanban",
          color: "Cor",
          tickets: "Registros Tags",
          contacts: "Contatos",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Tag",
        },
        toasts: {
          deleted: "Tag excluído com sucesso.",
        },
      },

      tagsKanban: {
        title: "Lanes",
        laneDefault: "Em aberto",
        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir esta Lane?",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        table: {
          name: "Nome",
          color: "Cor",
          tickets: "Tickets",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Lane",
        },
        toasts: {
          deleted: "Lane excluída com sucesso.",
        },
      },

      files: {
        title: "Lista de arquivos",
        table: {
          name: "Nome",
          contacts: "Contatos",
          actions: "Ação",
        },
        toasts: {
          deleted: "Lista excluída com sucesso!",
          deletedAll: "Todas as listas foram excluídas com sucesso!",
        },
        buttons: {
          add: "Adicionar",
          deleteAll: "Deletar Todos",
        },
        confirmationModal: {
          deleteTitle: "Deletar",
          deleteAllTitle: "Deletar Todos",
          deleteMessage: "Tem certeza que deseja deletar esta lista?",
          deleteAllMessage: "Tem certeza que deseja deletar todas as listas?",
        },
      },
      settings: {
        success: "Configurações salvas com sucesso.",
        title: "Configurações",
        tabs: {
          options: "Opções",
          plans: "Planos",
          helps: "Ajuda",
          myPlan: "Meu Plano",
        },
        settings: {
          userCreation: {
            name: "Criação de usuário",
            options: {
              enabled: "Ativado",
              disabled: "Desativado",
            },
          },
          tabs: {
            options: "Opções",
            schedules: "Horários",
            plans: "Planos",
            help: "Ajuda",
          },
          options: {
            disabled: "Desabilitado",
            enabled: "Habilitado",
            updating: "Atualizando...",
            creationCompanyUser: "Criação de Company/Usuário",
            evaluations: "Avaliações",
            officeScheduling: "Agendamento de Expediente",
            queueManagement: "Gerenciamento por Fila",
            companyManagement: "Gerenciamento por Empresa",
            connectionManagement: "Gerenciamento por Conexão",
            sendGreetingAccepted: "Enviar saudação ao aceitar o ticket",
            sendMsgTransfTicket:
              "Enviar mensagem transferência de setor/atendente",
            checkMsgIsGroup: "Ignorar Mensagens de Grupos",
            chatBotType: "Tipo do Bot",
            userRandom: "Escolher atendente aleatório",
            buttons: "Botões",
            acceptCallWhatsapp: "Informar que não aceita ligação no whatsapp?",
            sendSignMessage: "Permite atendente escolher ENVIAR Assinatura",
            sendGreetingMessageOneQueues:
              "Enviar saudação quando houver somente 1 fila",
            sendQueuePosition: "Enviar mensagem com a posição da fila",
            sendFarewellWaitingTicket:
              "Enviar mensagem de despedida no Aguardando",
            acceptAudioMessageContact:
              "Aceita receber audio de todos contatos?",
            enableLGPD: "Habilitar tratamento LGPD",
            requiredTag: "Tag obrigatoria para fechar ticket",
            requireClosureReason: "Classificação obrigatória",
            closeTicketOnTransfer:
              "Fechar ticket ao transferir para outra fila",
            DirectTicketsToWallets:
              "Mover automaticamente cliente para carteira",
            showNotificationPending:
              "Mostrar notificação para tickets pendentes",
            contactWalletEnabled: "Carteirização de Contatos",
            contactWalletEnabledHelper: "Atendentes visualizam apenas contatos da sua carteira",
            crossConnectionWarning: "Avisar atendimento em outra conexão",
            crossConnectionWarningHelper:
              "Mostra quando o cliente já está sendo atendido em outra conexão e avisa o atendente original",
            crossConnectionLastAttendanceHours: "Mostrar último atendimento de outra conexão",
            crossConnectionLastAttendanceHoursHelper:
              "Por quanto tempo depois do encerramento o atendente vê quem atendeu o cliente em outra conexão e o que foi registrado",
            crossConnectionLastAttendanceOff: "Desligado",
          },
          customMessages: {
            sendQueuePositionMessage: "Mensagem de posição na fila",
            AcceptCallWhatsappMessage:
              "Mensagem para informar que não aceita ligações",
            greetingAcceptedMessage: "Mensagem de Saudação ao aceitar ticket",
            transferMessage:
              "Mensagem de Transferência entre filas",
          },
          LGPD: {
            title: "LGPD",
            welcome: "Mensagem de boas vindas(LGPD)",
            linkLGPD: "Link da política de privacidade",
            obfuscateMessageDelete: "Ofuscar mensagem apagada",
            alwaysConsent: "Sempre solicitar consentimento",
            obfuscatePhoneUser: "Ofuscar número telefone para usuários",
            enabled: "Habilitado",
            disabled: "Desabilitado",
          },
          waba: {
            title: "WhatsApp Business API (WABA)",
            description: "Configure as opções de conexão via API Oficial do WhatsApp Business",
            enableEmbeddedSignup: "Cadastro via Meta",
            enableWabaCoexistence: "Coexistência",
            qualityAlerts: "Alertas de Qualidade",
            maxConnections: "Limite de conexões WABA",
            maxConnectionsHelp: "Máximo de conexões WABA permitidas para esta empresa",
          },
        },
      },
      aiProviderHealth: {
        title: "IA pausada — {{provider}} sem crédito.",
        titleNoGate: "{{provider}} sem crédito — a IA continua tentando enviar.",
        titleAwaiting: "{{provider}} sem crédito — aguardando confirmação do provedor.",
        body: "{{count}} agente(s) afetado(s): {{names}}. Recarregue o saldo no painel do provedor; a IA retoma sozinha em até {{minutes}} minuto(s) após a recarga.",
        bodyNoAgents: "Recarregue o saldo no painel do provedor.",
        andMore: "e {{count}} outro(s)",
        openProviderPanel: "Abrir painel do provedor",
        viewAgents: "Ver agentes",
        dismiss: "Fechar",
        badge: "Sem crédito",
        since: "desde {{since}}",
      },
      aiKeyUsage: {
        tab: "Chaves e uso",
        title: "Chaves e uso de IA",
        refresh: "Atualizar",
        retry: "Tentar de novo",
        loadError: "Não foi possível carregar as chaves e o uso.",
        rateLimited: "Muitas consultas em pouco tempo. Aguarde um instante e tente de novo.",
        providerHealthUnavailable: "Não foi possível consultar o crédito dos provedores agora.",
        updatedAt: "Atualizado em {{date}}",
        empty: "Nenhuma configuração de IA cadastrada.",
        noWarnings: "Nenhum problema encontrado.",
        fix: "Corrigir",
        sections: { warnings: "Avisos", features: "Recursos", keys: "Chaves" },
        columns: {
          feature: "Recurso",
          scope: "Escopo",
          status: "Status",
          key: "Chave",
          provider: "Provedor",
          model: "Modelo",
          origin: "Origem",
          active: "Ativa",
          usedBy: "Usada por",
          billing: "Crédito"
        },
        scopeGlobal: "Geral",
        scopeRemovedQueue: "Fila removida (#{{id}})",
        status: {
          ok: "OK",
          fallback: "Chave de reserva",
          missing: "Sem chave",
          billing_blocked: "Sem crédito",
          disabled: "Desligado",
          unknown: "Não foi possível verificar"
        },
        features: {
          agent_chat: "Agente (chat)",
          autonomous: "IA autônoma",
          classifier: "Classificador",
          sentiment: "Sentimento",
          summarize: "Resumo",
          suggestion: "Sugestão",
          transcription: "Transcrição",
          tts: "Voz",
          translation: "Tradução",
          language_detection: "Detecção de idioma",
          long_term_memory: "Memória de longo prazo",
          jev: "Entendimento (JEV)",
          legacy_prompt: "Prompt antigo"
        },
        slots: {
          apiKey: "chave principal",
          sentimentApiKey: "chave de sentimento",
          suggestionApiKey: "chave de sugestão",
          voiceApiKey: "chave de voz"
        },
        sources: { google_speech: "Google Speech", platform: "Chave da plataforma", none: "—" },
        key: {
          plaintext: "sem criptografia",
          undecryptable: "não decifra",
          noCreditUntil: "sem crédito até {{time}}"
        },
        keyWithQueue: "{{config}} (fila {{queue}})",
        yes: "Sim",
        no: "Não",
        warnings: {
          feature_without_key: "{{feature}} está ligado, mas não há chave compatível.",
          feature_without_key_queue: "{{feature}} está ligado na fila {{queue}}, mas não há chave compatível.",
          undecryptable_key: "A {{slot}} de \"{{configuration}}\" não pode ser lida. Cadastre a chave de novo.",
          billing_blocked: "{{feature}} está sem crédito no provedor {{provider}}.",
          fallback_key: "{{feature}} está usando a {{slot}} de \"{{configuration}}\", não uma chave própria.",
          plaintext_key: "A {{slot}} de \"{{configuration}}\" está guardada sem criptografia. Cadastre a chave de novo para protegê-la.",
          plaintext_key_prompt: "O prompt antigo \"{{name}}\" guarda a chave sem criptografia. Migre o atendimento para uma configuração de IA e desvincule o prompt da conexão.",
          plaintext_key_prompt_fields: "O prompt antigo \"{{name}}\" guarda sem criptografia: {{fields}}. Migre o atendimento para uma configuração de IA e desvincule o prompt da conexão.",
          plaintext_key_google: "A credencial do Google Speech está guardada sem criptografia.",
          ambiguous_selection: "Há mais de uma configuração possível para {{feature}}; o sistema pode usar qualquer uma.",
          diagnostic_error: "Não foi possível verificar {{feature}} agora. Tente atualizar em instantes.",
          tts_other_queues: "A voz só está configurada em algumas filas; tickets das demais filas ficam sem voz."
        }
      },
      messagesList: {
        header: {
          assignedTo: "Atribuído à:",
          dialogRatingTitle:
            "Deseja deixar uma avaliação de atendimento para o cliente?",
          dialogClosingTitle: "Finalizando o atendimento com o cliente!",
          dialogRatingCancel: "Resolver COM Mensagem de Despedida",
          dialogRatingSuccess: "Resolver e Enviar Avaliação",
          dialogRatingWithoutFarewellMsg: "Resolver SEM Mensagem de Despedida",
          ratingTitle: "Escolha um menu de avaliação",
          notMessage: "Selecione pelo menos uma mensagem para encaminhar.",
          amount: "Valor de prospecção",
          buttons: {
            return: "Retornar",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceitar",
            rating: "Enviar Avaliação",
            enableIntegration: "Habilitar integração",
            disableIntegration: "Desabilitar integração",
            logTicket: "Logs do Ticket",
            menu: "Mais opções",
            requiredTag: "Você deve atribuir uma tag antes de fechar o ticket.",
            activateAI: "Ativar IA",
            deactivateAI: "Desativar IA",
            activateAIConfirm: "Ativar IA com o agente",
            activateAISuccess: "IA ativada com sucesso!",
            deactivateAISuccess: "IA desativada. Atendimento retomado pelo operador.",
            selectAgent: "Selecione o Agente de IA",
          },
        },
        body: {
          greeting: "Envie uma mensagem para iniciar a conversa",
          today: "Hoje",
        },
        errors: {
          sendFailed: "Falha no envio da mensagem",
          window24hExpired: "⏰ Janela de 24h expirada. Use um template aprovado para reengajar o cliente.",
          rateLimit: "⚠️ Limite de mensagens atingido. Aguarde alguns minutos.",
          blocked: "🚫 Este contato bloqueou o número.",
          templateError: "📋 Erro no template",
          invalidNumber: "📵 Número inválido ou não é WhatsApp.",
        },
        deliveryErrors: {
          131026: "Não entregue — este número não tem WhatsApp ou não pode receber mensagens",
          131045: "Não enviado — o número da conexão precisa ser registrado novamente",
          131047: "Janela de 24h fechada — use um template aprovado para retomar a conversa",
          131049: "A Meta limitou o envio de marketing para este usuário — tente após 24h",
          131050: "Este usuário optou por não receber mensagens de marketing",
          130472: "Número participa de um experimento da Meta — não recebe marketing",
          130497: "A conta não pode enviar mensagens para o país deste número",
          131021: "Não é possível enviar para o próprio número da conexão",
          131053: "Falha ao enviar a mídia",
          131056: "Muitas mensagens para este número em pouco tempo — aguarde",
          131031: "Conta WhatsApp Business restrita ou desabilitada pela Meta",
          131042: "Problema com o método de pagamento da conta",
          132000: "Template: quantidade de parâmetros diferente do esperado",
          132001: "Template não existe ou não está aprovado neste idioma",
          132005: "Template: texto traduzido excede o limite",
          132007: "Template: conteúdo viola a política do WhatsApp",
          132012: "Template: parâmetro em formato inválido",
          132015: "Template pausado pela Meta por baixa qualidade",
          132016: "Template desabilitado pela Meta por baixa qualidade",
          codeLabel: "código {{code}}",
          genericWithCode: "Não entregue (código {{code}}): {{metaText}}",
          genericCodeOnly: "Não entregue (código {{code}})",
          genericNoCode: "Não entregue: {{metaText}}",
        },
        renderError: "Não foi possível exibir esta mensagem",
        mediaPending: {
          receiving: "Recebendo {{kind}}…",
          unavailable: "Mídia indisponível",
          kinds: {
            image: "imagem",
            video: "vídeo",
            audio: "áudio",
            ptt: "áudio",
            sticker: "figurinha",
            document: "documento",
            application: "documento",
            media: "mídia",
          },
        },
        search: {
          tooOld: "Mensagem muito antiga para localizar automaticamente. Role o histórico.",
          notFound: "Mensagem não encontrada neste atendimento (pode ter sido apagada).",
          jumpToLatest: "Ir para as mensagens mais recentes",
          jumpToLatestCount: "Ir para as mensagens mais recentes ({{count}} novas)",
        },
      },
      messagesInput: {
        placeholderPrivateMessage:
          "Digite uma mensagem ou aperte / para respostas rápidas",
        placeholderOpen: "Digite algo ou / para respostas rápidas",
        placeholderClosed:
          "Reabra ou aceite esse ticket para enviar uma mensagem.",
        groupUnavailable: "Você não faz mais parte deste grupo",
        signMessage: "Assinar",
        privateMessage: "Mensagem Privada",
      },
      contactDrawer: {
        header: "Dados do contato",
        buttons: {
          edit: "Editar contato",
          block: "Bloquear",
          unblock: "Desbloquear",
        },
        extraInfo: "Outras informações",
      },
      ticket: {
        tasks: {
          title: "Tarefas",
          empty: "Nenhuma tarefa pendente vinculada a este ticket.",
          createNew: "Nova Tarefa",
          addTask: "Adicionar Tarefa",
          pendingWarning: "Este ticket possui tarefas pendentes ou em progresso.",
          closeConfirmTitle: "Existem tarefas pendentes",
          closeConfirmMessage:
            "Este ticket possui tarefas pendentes ou em progresso. Deseja fechar mesmo assim?",
          closeAnyway: "Fechar Mesmo Assim",
        },
      },
      messageVariablesPicker: {
        label: "Variavéis disponíveis",
        vars: {
          contactFirstName: "Primeiro Nome",
          contactName: "Nome",
          user: "Atendente",
          greeting: "Saudação",
          protocolNumber: "Protocolo",
          date: "Data",
          hour: "Hora",
          ticket_id: "Nº do Chamado",
          queue: "Setor",
          connection: "Conexão",
        },
      },
      ticketOptionsMenu: {
        schedule: "Agendamento",
        delete: "Deletar",
        transfer: "Transferir",
        registerAppointment: "Observações do Contato",
        resolveWithNoFarewell: "Finalizar sem despedida",
        acceptAudioMessage: "Aceitar áudios",
        appointmentsModal: {
          title: "Observações do Ticket",
          textarea: "Observação",
          placeholder: "Insira aqui a informação que deseja registrar",
        },
        confirmationModal: {
          title: "Deletar o ticket do contato",
          titleFrom: "do contato ",
          message:
            "Atenção! Todas as mensagens relacionadas ao ticket serão perdidas.",
        },
        buttons: {
          delete: "Excluir",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageInput: {
        send: "Enviar mensagem",
        editing: "Editando",
        editingPlaceholder: "Edite a mensagem...",
        saveEdit: "Salvar edição",
        tooltip: {
          signature: "Habilitar/Desabilitar Assinatura",
          privateMessage: "Habilitar/Desabilitar Mensagem Privada",
          meet: "Enviar link para videoconferência",
          schedule: "Agendar mensagem",
        },
        buttons: {
          media: "Fotos e vídeos",
          camera: "Câmera",
          contact: "Contato",
          meet: "Reunião",
          document: "Documentos",
        },
      },
      messageOptionsMenu: {
        title: "Opções",
        delete: "Apagar",
        edit: "Editar",
        reply: "Responder",
        forward: "Encaminhar",
        talkTo: "Conversar",
        downloadAudio: "Baixar Áudio",
        markSpam: "Marcar como Spam",
        unmarkSpam: "Remover de Spam",
        spamMarked: "Marcado como spam",
        spamToasts: {
          markedSynced: "Email marcado como spam e sincronizado com o provedor",
          unmarkedSynced: "Email removido de spam e sincronizado com o provedor",
          markedLocal: "Email marcado como spam localmente (não sincronizado com provedor)",
          unmarkedLocal: "Email removido de spam localmente (não sincronizado com provedor)",
        },
        confirmationModal: {
          title: "Apagar mensagem",
          message: "Esta ação não pode ser revertida. Deseja continuar?",
        },
      },
      invoices: {
        table: {
          invoices: "Faturas",
          details: "Detalhes",
          users: "Usuários",
          connections: "Conexões",
          queue: "Filas",
          value: "Valor",
          expirationDate: "Data Venc.",
          action: "Ação",
        },
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP: "Deve haver pelo menos um WhatsApp padrão.",
        ERR_NO_DEF_WAPP_FOUND:
          "Nenhum WhatsApp padrão encontrado. Verifique a página de conexões.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sessão do WhatsApp não foi inicializada. Verifique a página de conexões.",
        ERR_WAPP_PAUSED:
          "Sessão do WhatsApp está pausada. Retome a conexão para enviar mensagens.",
        ERR_WAPP_CHECK_CONTACT:
          "Não foi possível verificar o contato do WhatsApp. Verifique a página de conexões",
        ERR_WAPP_INVALID_CONTACT: "Este não é um número de Whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Não foi possível baixar mídia do WhatsApp. Verifique a página de conexões.",
        ERR_INVALID_CREDENTIALS:
          "Erro de autenticação. Por favor, tente novamente.",
        ERR_SENDING_WAPP_MSG:
          "Erro ao enviar mensagem do WhatsApp. Verifique a página de conexões.",
        ERR_DELETE_WAPP_MSG: "Não foi possível excluir a mensagem do WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Já existe um tíquete aberto para este contato.",
        ERR_CONTACT_BLOCKED: "Este contato está bloqueado e não pode receber ou enviar mensagens.",
        ERR_SESSION_EXPIRED: "Sessão expirada. Por favor entre.",
        ERR_USER_CREATION_DISABLED:
          "A criação do usuário foi desabilitada pelo administrador.",
        ERR_NO_PERMISSION: "Você não tem permissão para acessar este recurso.",
        ERR_AI_FALLBACK_QUEUE_NOT_IN_COMPANY: "A Fila de Destino do fallback não existe mais nesta empresa. Escolha outra fila em Ações de Fallback.",
        ERR_AI_FALLBACK_USER_NOT_IN_COMPANY: "O supervisor configurado no fallback não pertence a esta empresa. Escolha outro usuário.",
        ERR_AI_FALLBACK_REF_INVALID: "Fila ou usuário de fallback inválido. Selecione um valor da lista.",
        ERR_INVALID_TRANSFER_TARGETS: "Filas de destino inválidas. Confira se as filas existem e não estão repetidas.",
        ERR_TRANSFER_TOOL_RENAME: "A ferramenta Transferir para fila não pode ser renomeada.",
        ERR_TEMPLATE_NAME_ALREADY_EXISTS: "Já existe um template com este nome.",
        ERR_NO_PERMISSION_DELETE_GROUP: "Apenas administradores podem deletar tickets de grupos.",
        ERR_CONTACT_WALLET_DISABLED: "A Carteirização de Contatos está desativada. Ative nas Configurações para usar este recurso.",
        ERR_DUPLICATED_CONTACT: "Já existe um contato com este número.",
        ERR_CONTACT_IN_OTHER_WALLET: "Este contato está atribuído à carteira de outro atendente. Solicite ao administrador a transferência.",
        ERR_NO_SETTING_FOUND: "Nenhuma configuração encontrada com este ID.",
        ERR_NO_CONTACT_FOUND: "Nenhum contato encontrado com este ID.",
        ERR_CONTACT_NOT_FOUND: "Contato não encontrado.",
        ERR_QUEUE_NOT_FOUND: "Fila não encontrada.",
        ERR_INVALID_SLOT_VALUE:
          "Valor do agendamento inválido. Use um número maior ou igual a zero, com até duas casas (ex.: 150,00).",
        ERR_SLOT_CANCELLED: "Este agendamento já foi cancelado.",
        ERR_SLOT_ALREADY_CANCELLED: "Este agendamento já estava cancelado.",
        ERR_SLOT_INVALID_STATE:
          "Este agendamento não está em um estado que permita esta ação.",
        ERR_CONTACT_NUMBER_LOCKED_OPTOUT:
          "Este contato pediu para não receber mensagens. Só administradores podem alterar o número.",
        ERR_CONSENT_REVERT_FORBIDDEN:
          "Somente administradores podem reverter opt-out de consentimento.",
        ERR_CONSENT_REASON_REQUIRED:
          "Informe o motivo (até 200 caracteres) para reverter o opt-out.",
        ERR_NO_TICKET_FOUND: "Nenhum tíquete encontrado com este ID.",
        ERR_GROUP_TRANSFER_TARGET_NO_ACCESS: "Esse atendente não tem acesso a este grupo.",
        ERR_INVALID_GROUP_ACCESS: "Lista de grupos inválida. Recarregue a tela e tente de novo.",
        ERR_NO_USER_FOUND: "Nenhum usuário encontrado com este ID.",
        ERR_NO_WAPP_FOUND: "Nenhum WhatsApp encontrado com este ID.",
        ERR_WAPP_NOT_CONNECTED: "WhatsApp não está conectado. Verifique a conexão.",
        ERR_NEWSLETTER_NOT_ADMIN: "Este número não é administrador do Canal.",
        ERR_CONNECTION_NEWSLETTER_ONLY: "Esta conexão está no modo somente Canais.",
        ERR_NEWSLETTER_DUPLICATE_PUBLISH: "Esta publicação já foi enviada. Aguarde e tente de novo.",
        ERR_NEWSLETTER_OWNER_RISK_NOT_ACCEPTED:
          "Confirme que entende o risco de este número ser o dono do Canal.",
        ERR_NEWSLETTER_NAME_REQUIRED: "Informe o nome do Canal.",
        ERR_NEWSLETTER_NAME_TOO_LONG: "O nome do Canal pode ter no máximo 100 caracteres.",
        ERR_NEWSLETTER_DESCRIPTION_TOO_LONG: "A descrição do Canal pode ter no máximo 2048 caracteres.",
        ERR_NEWSLETTER_DUPLICATE_CREATE: "Este Canal está sendo criado. Aguarde e tente de novo.",
        ERR_NEWSLETTER_CREATE_UNCONFIRMED:
          "Não foi possível confirmar se o Canal foi criado. Clique em Atualizar e confira a lista antes de tentar de novo.",
        ERR_NEWSLETTER_EDIT_WINDOW_EXPIRED: "O prazo para editar esta publicação expirou.",
        ERR_NEWSLETTER_MEDIA_TOO_LARGE: "O arquivo passa de 16 MB.",
        ERR_NEWSLETTER_MEDIA_TYPE: "Envie uma imagem ou um vídeo.",
        ERR_NEWSLETTER_PROVIDER_FAILURE: "O WhatsApp não confirmou a publicação.",
        ERR_NEWSLETTER_MEDIA_UPLOAD_FAILED: "Falha ao enviar a mídia do Canal.",
        ERR_NEWSLETTER_INVALID_JID: "Identificador do Canal inválido.",
        ERR_NEWSLETTER_POST_NOT_FOUND: "Publicação não encontrada.",
        ERR_NEWSLETTER_EDIT_TEXT_ONLY: "Só é possível editar publicações de texto.",
        ERR_NEWSLETTER_TEXT_REQUIRED: "Escreva o texto da publicação.",
        ERR_NEWSLETTER_TEXT_TOO_LONG: "O texto da publicação é longo demais.",
        ERR_NEWSLETTER_MEDIA_REQUIRED: "Envie uma imagem ou um vídeo.",
        ERR_NEWSLETTER_INVALID_TYPE: "Tipo de publicação inválido.",
        ERR_INVALID_WHATSMEOW_MODE: "Modo da conexão inválido.",
        ERR_WHATSMEOW_MODE_SAVE_FAILED: "Não foi possível salvar o modo da conexão.",
        ERR_WHATSMEOW_MODE_UNSUPPORTED: "O serviço do WhatsApp ainda não suporta o modo somente Canais. Atualize o microserviço.",
        ERR_NEWSLETTER_POST_NOT_PUBLISHED: "Esta publicação não está publicada.",
        ERR_NEWSLETTER_POST_BUSY: "Esta publicação está sendo alterada. Tente de novo em instantes.",
        ERR_NEWSLETTER_INVALID_REQUEST: "Não foi possível publicar com esses dados.",
        ERR_ONLY_WHATSMEOW: "Este recurso só funciona em conexões whatsmeow.",
        ERR_NO_WAPP_TOKEN: "Token do WhatsApp não encontrado. Reconecte a sessão.",
        ERR_QUEUE_REQUIRED_TO_ASSUME_TICKET: "Selecione uma fila antes de assumir o ticket.",
        // ✅ Erros de gerenciamento de grupos
        ERR_GROUP_NAME_REQUIRED: "Nome do grupo é obrigatório.",
        ERR_GROUP_PARTICIPANTS_REQUIRED: "Adicione pelo menos 1 participante ao grupo.",
        ERR_GROUP_JID_REQUIRED: "ID do grupo é obrigatório.",
        ERR_GROUP_NOT_FOUND: "Grupo não encontrado.",
        ERR_INVITE_CODE_REQUIRED: "Código de convite é obrigatório.",
        ERR_IMAGE_REQUIRED: "Imagem é obrigatória.",
        ERR_INVALID_IMAGE_FORMAT: "Formato de imagem inválido. Use JPEG.",
        ERR_GROUP_TOPIC_REQUIRED: "Descrição do grupo é obrigatória.",
        ERR_INVALID_EPHEMERAL_DURATION: "Duração inválida para mensagens temporárias.",
        ERR_NO_SETTINGS_PROVIDED: "Nenhuma configuração fornecida.",
        ERR_PHONES_REQUIRED: "Lista de telefones é obrigatória.",
        ERR_INVALID_ACTION: "Ação inválida. Use: add, remove, promote ou demote.",
        ERR_CREATE_GROUP: "Erro ao criar grupo.",
        ERR_NOT_GROUP_ADMIN: "Você não tem permissão. Apenas administradores do grupo podem realizar esta ação.",
        ERR_GROUP_ADMIN_UNVERIFIED: "Não foi possível confirmar que esta conexão é admin do grupo. Tente novamente em instantes.",
        ERR_GROUP_CHANNEL_NOT_SUPPORTED: "Grupos não estão disponíveis neste tipo de conexão.",
        ERR_GROUP_MANAGER_REQUIRED: "Somente administradores e supervisores podem executar esta ação no grupo.",
        ERR_NOT_GROUP_MEMBER: "Você não é membro deste grupo.",
        ERR_GET_INVITE_LINK: "Erro ao obter link de convite.",
        ERR_LIST_GROUPS: "Erro ao listar grupos.",
        ERR_GET_GROUP_INFO: "Erro ao obter informações do grupo.",
        ERR_LEAVE_GROUP: "Erro ao sair do grupo.",
        ERR_DISSOLVE_GROUP: "Erro ao desfazer o grupo.",
        ERR_GROUP_INFO_NOT_FOUND: "Informações do grupo não encontradas.",
        ERR_JOIN_GROUP: "Erro ao entrar no grupo.",
        ERR_GET_INVITE_INFO: "Erro ao obter informações do convite.",
        ERR_SET_GROUP_PHOTO: "Erro ao definir foto do grupo.",
        ERR_REMOVE_GROUP_PHOTO: "Erro ao remover foto do grupo.",
        ERR_SET_GROUP_NAME: "Erro ao alterar nome do grupo.",
        ERR_SET_GROUP_TOPIC: "Erro ao alterar descrição do grupo.",
        ERR_SET_GROUP_SETTINGS: "Erro ao alterar configurações do grupo.",
        ERR_UPDATE_PARTICIPANTS: "Erro ao atualizar participantes.",
        ERR_CREATING_MESSAGE: "Erro ao criar mensagem no banco de dados.",
        ERR_CREATING_TICKET: "Erro ao criar tíquete no banco de dados.",
        ERR_FETCH_WAPP_MSG:
          "Erro ao buscar a mensagem no WhatsApp, talvez ela seja muito antiga.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Esta cor já está em uso, escolha outra.",
        ERR_INVALID_DISTRIBUTION_STRATEGY:
          "Estratégia de distribuição inválida.",
        ERR_INVALID_MAX_CONCURRENT_TICKETS:
          "O máximo de atendimentos simultâneos deve ser um número inteiro de 0 a 1000.",
        ERR_QUEUE_PROMPTS_EXIST:
          "Não é possível excluir esta fila pois existem Prompts de IA associados a ela. Remova ou altere os Prompts primeiro.",
        ERR_QUEUE_HAS_ACTIVE_TICKETS:
          "Não é possível excluir esta fila: há atendimentos abertos ou aguardando nela. Transfira-os para outra fila antes.",
        ERR_QUEUE_IS_REDIRECT_TARGET:
          "Não é possível excluir esta fila: ela é a fila de redirecionamento (ou de fallback do Flow) de uma conexão. Altere a conexão antes.",
        ERR_WAPP_GREETING_REQUIRED:
          "A mensagem de saudação é obrigatório quando há mais de uma fila.",
        ERR_OUT_OF_HOURS: "Fora do Horário de Expediente!",
        ERR_TRANSFER_WHATSAPP_REQUIRED:
          "Selecione uma conexão de destino para transferir os tickets antes de prosseguir.",
        ERR_TRANSFER_WHATSAPP_INVALID_TARGET:
          "A conexão selecionada para transferência é inválida.",
        ERR_TRANSFER_WHATSAPP_TARGET_IN_REMOVAL:
          "A conexão escolhida para transferência também está sendo removida. Escolha outra.",
        ERR_TRANSFER_WHATSAPP_TARGET_NOT_FOUND:
          "Conexão de destino não encontrada para esta empresa.",
        ERR_TRANSFER_WHATSAPP_CHANNEL_MISMATCH:
          "A conexão de destino deve ser do mesmo canal (WhatsApp, Facebook ou Instagram).",
        ERR_TRANSFER_WHATSAPP_SAME_TARGET:
          "Selecione uma conexão diferente para transferência.",
        // ✅ Erros de WhatsApp Flows
        ERR_FLOW_NOT_FOUND: "Flow não encontrado.",
        ERR_FLOW_NOT_ON_META: "Este flow não está sincronizado com a Meta. Publique-o primeiro para sincronizar.",
        ERR_NO_WABA_CONNECTION: "Nenhuma conexão WABA encontrada. Configure uma conexão WhatsApp Business API primeiro.",
        ERR_CREATE_FLOW_ON_META: "Erro ao criar flow na Meta.",
        ERR_UPLOAD_FLOW_JSON: "Erro ao enviar JSON do flow para a Meta.",
        ERR_PUBLISH_FLOW_ON_META: "Erro ao publicar flow na Meta.",
        ERR_DEPRECATE_FLOW_ON_META: "Erro ao deprecar flow na Meta.",
        ERR_GET_FLOW_FROM_META: "Erro ao buscar flow na Meta.",
        ERR_GET_FLOW_PREVIEW: "Erro ao obter preview do flow.",
        ERR_NO_META_FLOW_ID: "ID do flow na Meta não retornado.",
        ERR_FLOW_ALREADY_IMPORTED: "Este flow já foi importado anteriormente.",
        ERR_CANNOT_EDIT_PUBLISHED_FLOW: "Não é possível editar um flow que já foi publicado.",
        ERR_CANNOT_DELETE_PUBLISHED_FLOW: "Não é possível excluir um flow que já foi publicado. Deprecie-o primeiro.",
        ERR_INVALID_CATEGORY: "Categoria do flow inválida.",
        ERR_FLOW_NOT_AVAILABLE: "Este flow não está disponível para envio.",
        ERR_SEND_FLOW_FAILED: "Erro ao enviar flow para o contato.",
        ERR_TEMPLATE_NOT_FOUND: "Template de flow não encontrado.",
        // ⚡ Erros de validação do Flow JSON
        ERR_FLOW_VALIDATION: "O JSON do Flow possui erros de validação. Verifique a estrutura do Flow e corrija os campos obrigatórios antes de publicar.",
        MISSING_REQUIRED_PROPERTY: "Propriedade obrigatória ausente no Flow JSON.",
        INVALID_ON_CLICK_ACTION_PAYLOAD: "Dados dinâmicos ausentes no payload da ação. Certifique-se que todos os campos usados estão definidos no data model.",
        INVALID_NAVIGATE_ACTION_PAYLOAD: "Campos obrigatórios ausentes no data model da próxima tela.",
        // 🔔 Erros de Equipes Colaborativas
        ERR_TEAM_NAME_REQUIRED: "Nome da equipe é obrigatório.",
        ERR_TEAM_NAME_TOO_LONG: "Nome da equipe deve ter no máximo 100 caracteres.",
        ERR_TEAM_QUEUE_REQUIRED: "Fila é obrigatória para criar uma equipe.",
        ERR_TEAM_QUEUE_NOT_FOUND: "Fila não encontrada ou não pertence a esta empresa.",
        ERR_TEAM_MEMBERS_REQUIRED: "Selecione pelo menos um membro para a equipe.",
        ERR_TEAM_USERS_NOT_IN_QUEUE: "Alguns membros selecionados não pertencem a esta fila.",
        ERR_TEAM_NOT_FOUND: "Equipe não encontrada.",
      },
      contactWallets: {
        title: "Carteiras de Contatos",
        description: "Gerencie a atribuição de contatos aos atendentes",
        global: "Global",
        assignedTo: "Atribuído a",
        setGlobal: "Tornar Global",
        assignTo: "Atribuir a...",
        selectUser: "Selecione um atendente",
        filters: {
          all: "Todos",
          global: "Globais",
          byUser: "Por Atendente"
        },
        table: {
          contact: "Contato",
          wallet: "Carteira",
          actions: "Ações"
        },
        toasts: {
          setGlobalSuccess: "Contato marcado como global com sucesso",
          assignSuccess: "Contato atribuído com sucesso",
          error: "Erro ao gerenciar carteira"
        }
      },
      profilePermissions: {
        title: "Permissões de Acesso",
        description: "Defina quais menus supervisores e atendentes podem visualizar.",
        helper: "Altere as marcações e clique em 'Salvar alterações'. A mudança é aplicada em instantes para usuários conectados.",
        propagation: "A mudança é aplicada em instantes para usuários conectados.",
        adminAlways: "Administradores sempre têm acesso total",
        loading: "Carregando permissões...",
        roles: {
          supervisor: "Supervisor",
          user: "Atendente"
        },
        table: {
          menu: "Menu"
        },
        actions: {
          save: "Salvar alterações",
          cancel: "Reverter alterações",
          saving: "Salvando...",
          retry: "Tentar novamente",
          markAll: "Marcar todos",
          unmarkAll: "Desmarcar todos",
          copyToUser: "Copiar supervisor → atendente",
          copyToSupervisor: "Copiar atendente → supervisor"
        },
        search: {
          label: "Buscar item",
          empty: "Nenhum item encontrado"
        },
        error: {
          load: "Não foi possível carregar as permissões."
        },
        unsaved: {
          label: "Alterações não salvas",
          prompt: "Há alterações de permissão sem salvar. Sair mesmo assim?"
        },
        copy: {
          title: "Copiar permissões",
          body: "As marcações de {{from}} substituem as de {{to}} nesta tela. Nada é gravado até salvar.",
          confirm: "Copiar",
          cancel: "Cancelar"
        },
        aria: {
          item: "{{label}}, {{role}}",
          toggleAll: "{{action}}, {{role}}"
        },
        toasts: {
          updated: "Permissões atualizadas. A mudança é aplicada em instantes para usuários conectados."
        }
      },
      storageManagement: {
        title: "Gerenciamento de Armazenamento",
        usage: "Uso de Disco",
        quota: "Limite",
        noQuota: "Quota não configurada",
        manage: "Armazenamento",
        cancel: "Cancelar",
        back: "Voltar",
        next: "Próximo",
        alerts: {
          warning: "Seu armazenamento está em {{percent}}%",
          critical: "Armazenamento crítico ({{percent}}%)",
          full: "Armazenamento cheio!"
        },
        tabs: {
          olderThanDays: "Limpeza por Idade",
          specificPeriod: "Limpeza por Período",
          dateRange: "Intervalo Personalizado"
        },
        cleanup: {
          analyze: "Analisar",
          execute: "Limpar Agora",
          confirmation: "Digite DELETAR para confirmar",
          started: "Limpeza iniciada com sucesso!",
          completed: "{{count}} mídias deletadas, {{size}} liberados",
          deleteOlderThan: "Deletar mídias com mais de X dias",
          month: "Mês",
          year: "Ano",
          startDate: "Data Início",
          endDate: "Data Fim"
        },
        preview: {
          title: "Preview da Limpeza",
          totalMessages: "Total de Mídias",
          spaceToFree: "Espaço a Liberar",
          oldestDate: "Data Mais Antiga",
          newestDate: "Data Mais Recente",
          breakdown: "Distribuição por Tipo",
          breakdownDetails: "Detalhes por tipo de mídia:"
        },
        breakdown: {
          images: "Imagens",
          videos: "Vídeos",
          audios: "Áudios",
          documents: "Documentos",
          other: "Outros"
        },
        confirm: {
          title: "Confirmar Limpeza de Mídias",
          step1: "Confirmação",
          step2: "Preview",
          step3: "Confirmação Final",
          step1Message: "Tem certeza que deseja deletar estas mídias? Esta ação não pode ser desfeita.",
          step3Message: "Para confirmar a exclusão, digite DELETAR no campo abaixo:",
          invalidWord: "Palavra incorreta. Digite 'DELETAR' para confirmar.",
          confirmDelete: "Confirmar Exclusão",
          executing: "Deletando mídias...",
          recentlyDeleted: "Últimos arquivos deletados"
        },
        errors: {
          invalidCriteria: "Critérios inválidos. Verifique os campos preenchidos.",
          noPreview: "Erro: Preview não encontrado. Por favor, analise novamente.",
          minioNotEnabled: "Limpeza de mídias só está disponível quando MinIO está habilitado."
        },
        history: {
          title: "Histórico de Limpezas",
          empty: "Nenhuma limpeza realizada ainda.",
          date: "Data",
          executedBy: "Executado por",
          deletedFiles: "Arquivos",
          freedSpace: "Espaço",
          duration: "Duração",
          status: "Status",
          rowsPerPage: "Itens por página:",
          criteria: "Critério utilizado"
        }
      },
      voip: {
        title: "Softphone",
        incomingCall: "Chamada recebida",
        outgoingCall: "Chamada realizada",
        notEnabled: "VoIP não está habilitado para este usuário",
        disconnected: "Conexão VoIP perdida",
        connectionFailed: "Falha ao conectar ao servidor VoIP",
        notRegistered: "Não registrado no servidor VoIP",
        alreadyInCall: "Já existe uma chamada em andamento",
        callFailed: "Falha ao realizar chamada",
        answerFailed: "Falha ao atender chamada",
        holdFailed: "Falha ao colocar em espera",
        transferSuccess: "Chamada transferida com sucesso",
        transferFailed: "Falha ao transferir chamada",
        noCallActive: "Nenhuma chamada ativa",
        ticketCreated: "Ticket criado com sucesso",
        ticketCreateFailed: "Falha ao criar ticket",
        callLinked: "Chamada vinculada ao ticket",
        linkFailed: "Falha ao vincular chamada",
        recordingAdded: "Gravação adicionada ao ticket",
        recordingAddFailed: "Falha ao adicionar gravação",
        dialpad: {
          title: "Teclado",
          call: "Ligar",
          placeholder: "Digite o número"
        },
        status: {
          idle: "Disponível",
          ringing: "Chamando...",
          incoming: "Recebendo chamada",
          connected: "Em chamada",
          onHold: "Em espera",
          ended: "Chamada encerrada"
        },
        controls: {
          mute: "Mudo",
          unmute: "Desmutar",
          hold: "Espera",
          resume: "Retomar",
          transfer: "Transferir",
          hangup: "Desligar",
          answer: "Atender",
          reject: "Rejeitar"
        },
        history: {
          title: "Chamadas Recentes",
          empty: "Nenhuma chamada recente",
          missed: "Perdida",
          inbound: "Recebida",
          outbound: "Realizada"
        },
        recording: {
          title: "Gravação",
          play: "Ouvir gravação",
          pause: "Pausar",
          download: "Download da gravação",
          noRecording: "Sem gravação disponível"
        }
      },
      myPlan: {
        title: "Meu Plano",
        subtitle: "Seu plano atual e recursos disponíveis",
        noPlan: "Nenhum plano encontrado",
        contactSupport: "Entre em contato com o suporte para verificar seu plano.",
        limits: {
          title: "Limites do Plano",
          users: "Usuários",
          connections: "Conexões",
          queues: "Filas/Setores",
          unlimited: "∞"
        },
        features: {
          title: "Recursos Habilitados",
          disabledTitle: "Recursos Não Incluídos",
          whatsapp: "WhatsApp (Wuzapi)",
          waba: "WhatsApp Business API",
          webchat: "Webchat",
          facebook: "Facebook Messenger",
          instagram: "Instagram Direct",
          telegram: "Telegram",
          campaigns: "Campanhas",
          schedules: "Agendamentos",
          kanban: "Kanban",
          openai: "Talk.AI",
          integrations: "Integrações",
          externalApi: "API Externa",
          internalChat: "Chat Interno",
          ifood: "iFood",
          sipPhone: "SIP Phone",
          email: "Email",
          googleCalendar: "Google Calendar"
        },
        footer: "Para alterar seu plano ou adicionar recursos, entre em contato com o suporte.",
        contactWhatsApp: "Falar no WhatsApp",
        whatsappMessage: "Olá! Gostaria de saber mais sobre os planos e recursos disponíveis."
      },
      // 🆕 Gerenciamento de Grupos WhatsApp
      whatsappGroups: {
        createModal: {
          title: "Criar Grupo WhatsApp",
          groupName: "Nome do Grupo",
          groupNamePlaceholder: "Ex: Equipe de Vendas",
          groupNameHelper: "Máximo 100 caracteres",
          participants: "Participantes",
          noParticipants: "Nenhum participante adicionado",
          addContacts: "Adicionar Contatos",
          searchPlaceholder: "Buscar por nome ou número...",
          noContacts: "Nenhum contato encontrado",
          typeToSearch: "Digite para buscar contatos",
          creating: "Criando grupo...",
          createButton: "Criar Grupo",
          cancelButton: "Cancelar",
          contactAlreadyAdded: "Contato já adicionado",
          nameRequired: "Digite um nome para o grupo",
          participantsRequired: "Adicione pelo menos 1 participante",
          noName: "Sem nome",
        },
        manageModal: {
          title: "Gerenciar Grupo",
          loading: "Carregando informações...",
          loadError: "Não foi possível carregar as informações do grupo",
          retry: "Tentar novamente",
          noDescription: "Sem descrição",
          participantsCount: "participantes",
          editDescription: "Descrição",
          saveButton: "Salvar",
          tabs: {
            participants: "Participantes",
            add: "Adicionar",
            link: "Link",
            settings: "Configurações",
          },
          participantsList: {
            noParticipants: "Nenhum participante encontrado",
            creator: "Criador",
            admin: "Admin",
            demote: "Rebaixar de Admin",
            promote: "Promover a Admin",
            remove: "Remover",
            privateContact: "Contato Privado",
            participantsCount: "participantes",
            refresh: "Atualizar lista",
          },
          addParticipants: {
            searchPlaceholder: "Buscar contato para adicionar...",
            noResults: "Nenhum contato encontrado",
            tryOtherSearch: "Tente outro termo de busca",
            typeToSearch: "Digite para buscar contatos",
          },
          photo: {
            save: "Salvar",
            cancel: "Cancelar",
            remove: "Remover foto",
            clickToChange: "Clique para alterar a foto",
            invalidFormat: "Formato inválido. Use JPG, PNG, GIF ou WebP.",
            tooLarge: "Imagem muito grande. Máximo 5MB.",
            readError: "Erro ao ler o arquivo.",
            invalidImage: "Arquivo de imagem inválido.",
            processError: "Erro ao processar imagem.",
          },
          inviteLink: {
            title: "Link de Convite",
            loading: "Carregando...",
            copyButton: "Copiar Link",
            generateNew: "Gerar Novo Link",
            copied: "Link copiado!",
            warning: "Qualquer pessoa com este link pode entrar no grupo. Gere um novo link para invalidar o anterior.",
          },
          settings: {
            announceMode: "Modo Anúncios",
            announceModeDesc: "Apenas admins podem enviar mensagens",
            restrictedGroup: "Grupo Restrito",
            restrictedGroupDesc: "Apenas admins podem editar info do grupo",
            actions: "Ações",
            leaveGroup: "Sair do Grupo",
            dissolveGroup: "Desfazer Grupo", // 🗑️ Novo
          },
          confirmLeave: {
            title: "Sair do Grupo",
            message: "Tem certeza que deseja sair do grupo",
            warning: "Você precisará de um convite para entrar novamente.",
          },
          confirmDissolve: { // 🗑️ Novo modal de confirmação
            title: "Desfazer Grupo",
            dangerTitle: "ESTA AÇÃO É IRREVERSÍVEL!",
            message: "Tem certeza que deseja desfazer o grupo",
            details: "Esta ação irá REMOVER TODOS os participantes do grupo e depois você sairá. O grupo deixará de existir para todos os membros.",
            warning: "Esta operação não pode ser desfeita!",
          },
          confirmRemove: {
            title: "Remover Participante",
            message: "Tem certeza que deseja remover este participante do grupo?",
          },
          defaultGroupName: "Grupo",
          closeButton: "Fechar",
        },
        menu: {
          createWithContact: "Criar Grupo com Contato",
        },
        toasts: {
          groupCreated: "Grupo criado com sucesso!",
          groupUpdated: "Grupo atualizado com sucesso!",
          participantAdded: "Participante adicionado!",
          participantRemoved: "Participante removido!",
          participantPromoted: "Participante promovido a admin!",
          participantDemoted: "Participante rebaixado!",
          cannotResolveParticipant: "Não foi possível identificar o número do participante. Tente novamente.",
          leftGroup: "Você saiu do grupo!",
          linkCopied: "Link copiado!",
          linkGenerated: "Novo link gerado!",
          settingsUpdated: "Configurações atualizadas!",
          error: "Erro ao executar operação",
        },
        // ✅ Mensagens de toast do hook useWhatsAppGroups
        hook: {
          groupCreated: 'Grupo "{{name}}" criado com sucesso!',
          leftGroup: "Você saiu do grupo",
          dissolvedGroup: "Grupo desfeito com sucesso!", // 🗑️ Novo
          joinedGroup: "Você entrou no grupo!",
          inviteLinkReset: "Link de convite resetado!",
          photoUpdated: "Foto do grupo atualizada!",
          photoRemoved: "Foto do grupo removida!",
          nameUpdated: "Nome do grupo atualizado!",
          topicUpdated: "Descrição do grupo atualizada!",
          settingsUpdated: "Configurações do grupo atualizadas!",
          participantsAdded: "Participantes adicionados",
          participantsRemoved: "Participantes removidos",
          participantsPromoted: "Participantes promovidos a admin",
          participantsDemoted: "Admins rebaixados a participantes",
          participantsPartialFailure: "{{count}} participante(s) não puderam ser atualizados: {{list}}",
          actionSuccess: "Ação realizada com sucesso!",
          linkCopied: "Link copiado para a área de transferência!",
          linkCopyError: "Erro ao copiar link",
        },
      },
      // 🆕 Página de Grupos WhatsApp
      whatsappGroupsPage: {
        title: "Grupos WhatsApp",
        search: {
          placeholder: "Buscar grupos...",
        },
        filter: {
          connection: "Conexão",
          allConnections: "Todas as conexões",
        },
        buttons: {
          createGroup: "Criar Grupo",
          joinViaLink: "Entrar via Link",
          refresh: "Atualizar",
          retry: "Tentar novamente",
        },
        joinLink: {
          placeholder: "Cole o link de convite aqui...",
          button: "Entrar",
        },
        card: {
          participants: "participantes",
          admins: "admins",
          noDescription: "Sem descrição",
          noName: "Grupo sem nome",
          copyLink: "Copiar Link",
          manage: "Gerenciar",
          openChat: "Abrir conversa",
        },
        groupUnavailable: "Você não faz mais parte deste grupo",
        empty: {
          title: "Nenhum grupo encontrado",
          subtitle: "Crie um novo grupo ou entre em um grupo existente usando um link de convite.",
          noConnection: "Nenhuma conexão WhatsApp disponível",
          noConnectionSubtitle: "Conecte uma conta WhatsApp para gerenciar grupos.",
        },
        error: {
          loadFailed: "Erro ao carregar grupos. Verifique sua conexão e tente novamente.",
        },
        toast: {
          linkCopied: "Link copiado para a área de transferência!",
          linkError: "Erro ao obter link de convite",
          invalidLink: "Insira um link de convite válido",
          noConnection: "Selecione uma conexão WhatsApp",
          noTicket: "Este grupo ainda não possui uma conversa. Envie uma mensagem no grupo para criar o ticket.",
        },
      },

      // ========================================
      // TASKS - Gerenciamento de Tarefas
      // ========================================
      tasks: {
        title: "Tarefas",
        newTask: "Nova Tarefa",
        editTask: "Editar Tarefa",
        viewTask: "Detalhes da Tarefa",
        deleteConfirm: "Excluir tarefa",
        deleteMessage: "Tem certeza que deseja excluir esta tarefa?",
        
        // Popover
        popover: {
          title: "Minhas Tarefas",
          tabs: {
            tasks: "Tarefas",
            notifications: "Atividade",
            announcements: "Informativos",
          },
          pending: "pendentes",
          inProgress: "em progresso",
          viewAll: "Ver todas as tarefas",
          emptyTasks: "Nenhuma tarefa pendente! 🎉",
          emptyNotifications: "Nenhuma notificação pendente",
          approval: {
            title: "Aprovação Solicitada",
            someone: "Alguém",
            wantsToChange: "quer mudar",
            from: "de",
            to: "para",
            approve: "Aprovar",
            reject: "Rejeitar",
            approved: "Mudança de status aprovada!",
            rejected: "Mudança de status rejeitada",
            error: "Erro ao processar aprovação",
          },
        },
        
        // Status
        status: {
          pending: "Pendente",
          in_progress: "Em Progresso",
          completed: "Concluído",
          cancelled: "Cancelado",
        },
        
        // Prioridade
        priority: {
          high: "Alta",
          medium: "Média",
          low: "Baixa",
        },
        
        // Campos
        fields: {
          title: "Título",
          description: "Descrição",
          priority: "Prioridade",
          status: "Status",
          dueDate: "Vencimento",
          participants: "Participantes",
          contact: "Contato Vinculado",
          createdBy: "Criado por",
          createdAt: "Criado em",
          completedAt: "Concluído em",
        },
        
        // Alertas
        alerts: {
          title: "Alertas Configurados",
          firstAlert: "Alerta (dias antes)",
          secondAlert: "Alerta (horas/min)",
          none: "Nenhum",
          daysBefore: "{{count}} dia antes",
          daysBefore_plural: "{{count}} dias antes",
          hoursBefore: "{{count}} hora antes",
          hoursBefore_plural: "{{count}} horas antes",
          minutesBefore: "{{count}} minutos antes",
        },
        
        // Anexos
        attachments: {
          title: "Anexos",
          upload: "Anexar",
          uploading: "Enviando...",
          download: "Baixar",
          delete: "Excluir",
          preview: "Visualizar",
          empty: "Nenhum anexo. Clique em \"Anexar\" para adicionar.",
          deleteConfirm: "Excluir anexo \"{{filename}}\"?",
          uploadSuccess: "Anexo enviado com sucesso!",
          uploadError: "Erro ao enviar anexo",
          downloadError: "Erro ao baixar anexo",
          deleteError: "Erro ao excluir anexo",
          deleteSuccess: "Anexo excluído",
          invalidType: "Tipo de arquivo não permitido. Use imagens, vídeos ou PDFs.",
          tooLarge: "Arquivo muito grande. O limite é 50MB.",
          previewTitle: "Visualizar Anexo",
          close: "Fechar",
          noPreviewAvailable: "Prévia não disponível para este tipo de arquivo",
          previewError: "Erro ao carregar prévia",
        },
        
        // Observações
        observations: {
          title: "Observações",
          placeholder: "Escreva uma observação... Use @ para mencionar",
          empty: "Nenhuma observação ainda.",
          reply: "Responder",
          edit: "Editar",
          delete: "Excluir",
          edited: "editado",
          deleteConfirm: "Excluir esta observação?",
        },
        
        // Histórico
        logs: {
          title: "Histórico",
          actions: {
            created: "Tarefa criada",
            updated: "Tarefa atualizada",
            completed: "Tarefa concluída",
            cancelled: "Tarefa cancelada",
            reopened: "Tarefa reaberta",
            status_changed: "Status alterado",
            participant_added: "Participante adicionado",
            participant_removed: "Participante removido",
            attachment_added: "Anexo adicionado",
            attachment_removed: "Anexo removido",
            observation_added: "Observação adicionada",
          },
        },
        
        // Botões
        buttons: {
          save: "Salvar",
          cancel: "Cancelar",
          close: "Fechar",
          edit: "Editar Tarefa",
          history: "Histórico",
          refresh: "Atualizar",
        },
        
        // Mensagens
        messages: {
          loadError: "Erro ao carregar tarefas",
          saveSuccess: "Tarefa salva com sucesso!",
          saveError: "Erro ao salvar tarefa",
          deleteSuccess: "Tarefa excluída com sucesso!",
          deleteError: "Erro ao excluir tarefa",
          titleRequired: "Título é obrigatório",
        },
        
        // Mídias do Ticket
        ticketMedia: {
          title: "Mídias do Ticket",
          preview: "Visualizar Mídia",
          noPreview: "Prévia não disponível para este tipo de arquivo",
          imageAlt: "Mídia do ticket",
        },
        
        // Kanban
        kanban: {
          emptyColumn: "Nenhuma tarefa",
          dragHint: "Arraste para mover",
        },
      },
      
      // Classificação de Tickets
      ticketClassification: {
        title: "Classificação de Tickets",
        closureReasons: "Motivos de Encerramento",
        demandTypes: "Tipos de Demanda",
        closureReasonsDescription: "Configure os motivos de encerramento de tickets",
        demandTypesDescription: "Configure os tipos de demanda para classificar tickets",
        add: "Adicionar",
        edit: "Editar",
        delete: "Excluir",
        name: "Nome",
        code: "Código",
        color: "Cor",
        resolution: "Resolução",
        sla: "SLA (min)",
        slaMinutes: "SLA em minutos",
        defaultQueue: "Fila Padrão",
        status: "Status",
        actions: "Ações",
        confirmDelete: "Tem certeza que deseja excluir? Isso pode afetar tickets existentes.",
        created: "Criado com sucesso!",
        updated: "Atualizado com sucesso!",
        deleted: "Excluído com sucesso!",
        editClosureReason: "Editar Motivo de Encerramento",
        newClosureReason: "Novo Motivo de Encerramento",
        editDemandType: "Editar Tipo de Demanda",
        newDemandType: "Novo Tipo de Demanda",
        save: "Salvar",
        cancel: "Cancelar",
      },
      
      // Modal de Encerramento de Ticket (legado)
      ticketClose: {
        title: "Encerrar Atendimento",
        closureReason: "Motivo do Encerramento",
        resolutionNotes: "Observações",
        resolutionNotesPlaceholder: "Descreva como o atendimento foi resolvido...",
        cancel: "Cancelar",
        confirm: "Encerrar",
        requiresNotes: "Este motivo requer observações",
        selectReason: "Selecione um motivo de encerramento",
      },

      // Novo Modal de Encerramento de Ticket
      closeTicketModal: {
        // Modo com classificação obrigatória
        classificationTitle: "Encerrar Atendimento",
        classificationSubtitle: "Selecione o motivo de encerramento para classificar este atendimento.",
        closureReason: "Motivo do Encerramento",
        demandType: "Tipo de Demanda",
        noDemandType: "Não especificado",
        resolutionNotes: "Observações",
        resolutionNotesPlaceholder: "Descreva como o atendimento foi resolvido...",
        confirmWithFarewell: "Encerrar com Despedida",
        confirmWithoutFarewell: "Encerrar sem Despedida",
        cancel: "Cancelar",
        
        // Modo simples (sem classificação)
        simpleTitle: "Encerrar Atendimento",
        simpleSubtitle: "Como você deseja encerrar este atendimento?",
        closeWithFarewell: "Encerrar com Despedida",
        closeWithFarewellDesc: "Envia mensagem de despedida antes de fechar",
        closeWithoutFarewell: "Encerrar sem Mensagem",
        closeWithoutFarewellDesc: "Fecha o atendimento silenciosamente",
        unreadWarning: "Este ticket possui {{count}} mensagem(ns) não lida(s). Tem certeza que deseja encerrar sem ler?",
        unreadWarningPending: "Este ticket possui {{count}} mensagem(ns) não lida(s) que não foram visualizadas por nenhum atendente. Deseja encerrar mesmo assim?",
      },
      // Automações Unificadas
      automations: {
        title: "Automações",
        buttons: {
          add: "Nova Automação",
          refresh: "Atualizar",
          clearFilters: "Limpar Filtros",
        },
        table: {
          status: "Status",
          name: "Nome",
          trigger: "Gatilho",
          actions: "Ações",
          executions: "Execuções",
          lastExecution: "Última Execução",
          options: "Opções",
        },
        triggers: {
          // Gatilhos originais
          ticket_created: "Ticket Criado",
          funnel_entry: "Entrada no Funil",
          funnel_move: "Mudança de Etapa",
          time_in_stage: "Tempo na Etapa",
          inactivity: "Inatividade",
          score_changed: "Score Alterado",
          value_set: "Valor Definido",
          message_received: "Mensagem Recebida",
          ticket_closed: "Ticket Fechado",
          // Fase 1 - Novos gatilhos
          user_assigned: "Atendente Atribuído",
          queue_changed: "Fila Alterada",
          first_response: "Primeira Resposta",
          contact_returned: "Contato Retornou",
          keyword_detected: "Palavra-chave Detectada",
          // Fase 2 - SLA e Mídia
          sla_warning: "Alerta de SLA",
          sla_breached: "SLA Violado",
          media_received: "Mídia Recebida",
          ticket_transferred: "Ticket Transferido",
          // Fase 2 - Baseados em Tempo
          birthday_today: "Aniversário Hoje",
          business_hours_start: "Início do Expediente",
          business_hours_end: "Fim do Expediente",
          // Fase 3
          contact_created: "Contato Criado",
          contact_field_updated: "Campo de Contato Alterado",
          webhook_received: "Webhook Recebido",
          // AI Automation Integration
          ai_handoff_triggered: "Handoff de IA",
          ai_response_generated: "Resposta de IA Gerada",
          // Fase B - AI triggers
          ai_sentiment_detected: "Sentimento Detectado pela IA",
          ai_intent_classified: "Intenção Classificada pela IA",
          ai_tool_executed: "Ferramenta de IA Executada",
          ai_turn_limit_approaching: "Limite de Turnos Próximo",
          // Fase C - General triggers
          tag_added: "Tag Adicionada",
          tag_removed: "Tag Removida",
          ticket_reopened: "Ticket Reaberto",
          nps_received: "NPS Recebido",
          outside_business_hours: "Fora do Horário Comercial",
        },
        // 🤖🔄 AI Automation Integration - Actions
        aiActions: {
          activate_autonomous_mode: "Ativar Modo Autônomo",
          aiConfigurationId: "Agente de IA",
          maxTurnsOverride: "Limite de Turnos (Override)",
          customContextPrompt: "Contexto Adicional",
          fallbackActionOverride: "Ação de Fallback (Override)",
          sendInitialMessage: "Enviar Mensagem Inicial",
          initialMessage: "Mensagem Inicial",
          maxActivationDepth: "Profundidade Máxima",
        },
        // Fase B/C - Novos action configs
        actionConfigs: {
          ai_summarize_ticket: "Resumir Ticket com IA",
          ai_classify_intent: "Classificar Intenção com IA",
          ai_analyze_sentiment: "Analisar Sentimento com IA",
          ai_generate_voice: "Gerar Áudio com IA",
          ai_smart_route: "Roteamento Inteligente com IA",
          ai_handoff_summary: "Gerar Briefing de Handoff",
          ai_pause_autonomous: "Pausar Modo Autônomo",
          add_internal_note: "Adicionar Nota Interna",
          send_reaction: "Enviar Reação (Emoji)",
          transfer_ticket: "Transferir Ticket",
          mark_as_resolved: "Marcar como Resolvido",
          // Campos de configuração
          summaryFormat: "Formato do Resumo",
          summaryFormatOptions: {
            brief: "Breve",
            detailed: "Detalhado",
            bullet: "Tópicos",
          },
          includeActionItems: "Incluir itens de ação",
          includeSentiment: "Incluir sentimento",
          saveAsNote: "Salvar como nota no ticket",
          minConfidence: "Confiança Mínima",
          autoRoute: "Auto-rotear baseado na intenção",
          saveAsTag: "Salvar intenção como tag",
          escalateOnNegative: "Escalar em sentimento negativo",
          escalateQueueId: "Fila para escalação",
          notifySupervisor: "Notificar supervisor",
          text: "Texto para gerar áudio",
          textPlaceholder: "Olá {{contact.name}}, seu ticket #{{ticket.id}}...",
          provider: "Provedor de voz",
          voiceId: "ID da Voz",
          allowQueueChange: "Permitir mudança de fila",
          allowAgentChange: "Permitir mudança de atendente",
          notifyOnRoute: "Notificar sobre roteamento",
          attachToTicket: "Anexar briefing ao ticket",
          includeStepsTaken: "Incluir passos realizados",
          includeSuggestedActions: "Incluir ações sugeridas",
          notifyAgent: "Notificar atendente",
          notifyOnPause: "Notificar ao pausar",
          noteContent: "Conteúdo da Nota",
          noteContentPlaceholder: "Use {{contact.name}} e {{ticket.id}} como variáveis",
          emoji: "Emoji",
          emojiPlaceholder: "👍",
          targetType: "Tipo de Transferência",
          targetTypeOptions: {
            queue: "Fila",
            user: "Atendente",
          },
          targetQueueId: "Fila de Destino",
          targetUserId: "Atendente de Destino",
          keepCurrentUser: "Manter atendente atual na fila",
          addNote: "Adicionar nota de resolução",
          noteMessage: "Mensagem da Nota",
          noteMessagePlaceholder: "Ticket resolvido por automação.",
        },
        // 🤖🔄 AI Automation Integration - Trigger configs
        aiTriggers: {
          handoffReasons: "Motivos de Handoff",
          aiConfigurationIds: "Agentes de IA",
          fallbackActions: "Ações de Fallback",
          confidenceThreshold: "Faixa de Confiança",
          turnCountThreshold: "Após N Turnos",
          handoffReasonsOptions: {
            low_confidence: "Baixa Confiança",
            turn_limit: "Limite de Turnos",
            customer_request: "Cliente Pediu Humano",
            customer_satisfied: "Cliente Satisfeito",
            error: "Erro",
            timeout: "Timeout",
          },
          fallbackActionsOptions: {
            notify_supervisor: "Notificar Supervisor",
            transfer_queue: "Transferir para Fila",
            notify_owner: "Notificar Dono",
            pause_bot: "Pausar Bot",
            close_ticket: "Fechar Ticket",
          },
        },
        modal: {
          createTitle: "Nova Automação",
          editTitle: "Editar Automação",
          save: "Salvar",
          cancel: "Cancelar",
          sections: {
            basicInfo: "Informações Básicas",
            trigger: "Gatilho (Quando executar)",
            actions: "Ações (O que fazer)",
            preview: "Preview do Fluxo",
          },
          fields: {
            name: "Nome da Automação",
            description: "Descrição",
            priority: "Prioridade",
            active: "Ativa",
            triggerType: "Tipo de Gatilho",
            stageId: "ID da Etapa",
            delayMinutes: "Delay (minutos)",
          },
        },
        confirmDelete: {
          title: "Excluir Automação",
          message: "Tem certeza que deseja excluir a automação \"{{name}}\"? Esta ação não pode ser desfeita.",
        },
        logs: {
          title: "Logs de Execução",
          empty: "Nenhum log encontrado",
          columns: {
            date: "Data",
            action: "Ação",
            status: "Status",
            time: "Tempo",
            error: "Erro",
          },
          status: {
            success: "Sucesso",
            error: "Erro",
            skipped: "Ignorado",
          },
        },
        empty: {
          title: "Nenhuma automação encontrada",
          description: "Crie sua primeira automação para começar",
        },
        toasts: {
          created: "Automação criada com sucesso",
          updated: "Automação atualizada com sucesso",
          deleted: "Automação excluída com sucesso",
          activated: "Automação ativada",
          deactivated: "Automação desativada",
          duplicated: "Automação duplicada",
          error: "Erro ao processar automação",
        },
      },
      // Jornada do Cliente
      journey: {
        title: "Jornada do Cliente",
        filters: {
          startDate: "Data Inicial",
          endDate: "Data Final",
        },
        summary: {
          totalLeads: "Total de Leads",
          inFunnel: "No Funil",
          conversion: "Conversão",
          totalValue: "Valor Total",
        },
        tabs: {
          overview: "Visão Geral",
          bySource: "Por Origem",
          campaigns: "Campanhas",
        },
        charts: {
          funnel: "Funil de Vendas",
          conversionBySource: "Conversão por Origem",
          forecast: "Previsão de Receita",
          campaignROI: "ROI de Campanhas",
        },
        sources: {
          organic: "Orgânico",
          campaign: "Campanha",
          waba_flow: "WhatsApp Flow",
          meta_flow: "Meta Flow",
          webchat: "Webchat",
          telegram: "Telegram",
          facebook: "Facebook",
          instagram: "Instagram",
          voip: "VoIP",
          import: "Importação",
        },
        forecast: {
          title: "Previsão de Receita",
          expectedDeals: "negócios esperados",
          byStage: "Por Etapa (ponderado por probabilidade)",
        },
        empty: {
          noData: "Nenhum dado disponível",
          loading: "Carregando...",
        },
      },

      // ========================================
      // VOICE API SETTINGS
      // ========================================
      voiceApiSettings: {
        title: "Integração Voice AI",
        description: "Configure a integração entre o FusionPBX e o OmniPlay",
        status: {
          active: "Ativa",
          inactive: "Inativa",
          generating: "Gerando...",
          revoking: "Revogando...",
        },
        token: {
          label: "Token de API",
          labelNew: "Token de API (COPIE AGORA!)",
          masked: "voice_••••••••••••••••",
          helperExisting: "Token existente. Gere um novo se precisar do valor completo.",
          copied: "Token copiado para a área de transferência!",
          copyWarning: "Gere um novo token para poder copiar.",
        },
        buttons: {
          generate: "Gerar Token de API",
          generateNew: "Gerar Novo Token",
          revoke: "Revogar Token",
          refresh: "Atualizar",
        },
        alerts: {
          copyNow: "⚠️ ATENÇÃO: Copie o token agora! Por segurança, ele não será exibido novamente.",
          noToken: "Nenhum token configurado. Gere um token para habilitar a integração.",
          revokeConfirm: "Tem certeza que deseja revogar o token? A integração com o FusionPBX será desabilitada.",
          keepSecret: "O token deve ser mantido em segredo. Qualquer pessoa com acesso ao token pode consultar filas e usuários da sua empresa.",
        },
        info: {
          title: "O que é a Integração Voice AI?",
          description: "Permite que o FusionPBX (seu sistema de telefonia) se conecte ao OmniPlay para:",
          features: {
            queues: "Buscar filas automaticamente para direcionar tickets de voz",
            users: "Listar usuários disponíveis para callback",
            tickets: "Criar tickets a partir de chamadas telefônicas",
          },
        },
        instructions: {
          title: "Como Configurar no FusionPBX",
          step1: "Acesse o FusionPBX → Voice Secretary → 🔗 OmniPlay",
          step2: "Cole a URL da API e o Token gerado acima",
          step3: "Clique em \"Testar Conexão\" para verificar",
          step4: "Clique em \"Forçar Sincronização\" para carregar filas e usuários",
          apiUrl: "URL da API:",
        },
        apiReference: {
          title: "Referência da API",
          description: "Endpoints disponíveis para sistemas externos:",
          ping: "Testa a conexão e retorna ID da empresa",
          queues: "Lista todas as filas da empresa",
          users: "Lista todos os usuários da empresa (opcional: ?queueId=X)",
          company: "Retorna informações da empresa (contagem de filas/usuários, timezone)",
        },
        expiresAt: "Expira em:",
        errors: {
          load: "Erro ao carregar informações do token",
          generate: "Erro ao gerar token",
          revoke: "Erro ao revogar token",
        },
        success: {
          generate: "Token gerado com sucesso!",
          revoke: "Token revogado com sucesso",
        },
      },
      // Embedded Signup - WABA Self-Service
      embeddedSignup: {
        connectWithMeta: "Conectar via Meta Business",
        connectWithCoexistence: "Conectar com Coexistência",
        connected: "Conectado com Sucesso",
        description: "Conecte sua conta WhatsApp Business em poucos cliques - sem copiar tokens manualmente",
        descriptionShort: "Conecte em poucos cliques - sem copiar tokens",
        orManual: "ou configure manualmente abaixo",
        // Accordion Labels
        recommended: "Recomendado",
        advanced: "Avançado",
        manualConfig: "Configuração Manual",
        manualConfigDescription: "IDs e tokens do Facebook Developer Console",
        webhookConfig: "Configuração de Webhook",
        webhookConfigDescription: "Configure para receber mensagens",
        integrationStatus: "Status da Integração",
        integrationStatusDescription: "Validação e teste de conexão",
        loadingConfig: "Carregando configuração...",
        loadingSDK: "Carregando Facebook SDK...",
        processing: "Processando cadastro...",
        success: "Conexão WhatsApp Business API criada com sucesso!",
        cancelled: "Cadastro cancelado",
        cancelledMessage: "O cadastro foi cancelado. Clique para tentar novamente.",
        successMessage: "Sua conta WhatsApp Business API foi conectada com sucesso!",
        reviewPending: "Nota: Sua conta está em revisão pela Meta. Isso pode levar até 72 horas.",
        tryAgain: "Tentar Novamente",
        connectionLimitReached: "Limite de {{max}} conexões do plano atingido ({{current}}/{{max}}). Entre em contato com o suporte para aumentar seu limite.",
        featureDisabled: "Embedded Signup não está habilitado para sua empresa. Entre em contato com o suporte.",
        coexistenceDisabled: "Modo coexistência não está habilitado para sua empresa.",
        step: "Passo",
        of: "de",
        // Coexistência
        coexistenceOption: "Manter WhatsApp Business App ativo (Coexistência)",
        coexistenceTooltip: "Clique para saber mais sobre o modo coexistência",
        coexistenceTitle: "O que é Coexistência?",
        coexistenceDescription: "Permite usar o WhatsApp Business App e a API oficial ao mesmo tempo no mesmo número.",
        coexistenceBenefit1: "Continue usando o app no celular",
        coexistenceBenefit2: "Receba mensagens em ambos os canais",
        coexistenceBenefit3: "Importação de histórico de até 6 meses",
        coexistenceLimitations: "Limitações: Grupos não sincronizam, algumas funções do app ficam desabilitadas.",
        // Steps
        steps: {
          facebook_login: "Login Facebook",
          select_waba: "Selecionar Conta",
          select_phone: "Selecionar Número",
          verify_phone: "Verificar Número",
          register: "Registrar",
          sync_templates: "Sincronizar Templates",
          complete: "Concluído"
        },
        // Steps Descriptions
        stepsDescription: {
          facebook_login: "Faça login com sua conta do Facebook para autorizar o acesso.",
          select_waba: "Selecione ou crie sua conta WhatsApp Business.",
          select_phone: "Escolha o número de telefone que será conectado.",
          verify_phone: "Verifique o número com o código enviado por SMS ou ligação.",
          register: "Registrando o número na API do WhatsApp Business.",
          sync_templates: "Sincronizando templates de mensagem existentes.",
          complete: "Cadastro finalizado! Sua conexão está pronta para uso."
        },
        // Progress
        progress: "Progresso do Cadastro",
        coexistenceMode: "Modo Coexistência",
        coexistenceNote: "Modo coexistência: você poderá usar o WhatsApp Business App e a API simultaneamente.",
        // Errors
        errors: {
          loadConfigFailed: "Erro ao carregar configuração. Tente novamente.",
          sdkLoadFailed: "Erro ao carregar Facebook SDK. Verifique sua conexão.",
          noAppId: "Configuração do Facebook App não encontrada.",
          notAuthorized: "Você não autorizou o acesso. Tente novamente.",
          startFailed: "Erro ao iniciar cadastro. Tente novamente.",
          processingFailed: "Erro ao processar cadastro. Tente novamente.",
          unknown: "Ocorreu um erro desconhecido."
        }
      },
      // Quality Rating
      wabaQuality: {
        limit: "Limite",
        green: {
          title: "Quality Rating: Bom",
          label: "Bom",
          description: "Sua conta está em bom estado. Continue mantendo boas práticas de mensagens."
        },
        yellow: {
          title: "Quality Rating: Atenção",
          label: "Atenção",
          description: "Sua conta está em alerta. Melhore a qualidade das suas mensagens para evitar restrições."
        },
        red: {
          title: "Quality Rating: Crítico",
          label: "Crítico",
          description: "Sua conta está em estado crítico. O limite de mensagens pode ser reduzido. Revise suas práticas imediatamente."
        },
        unknown: {
          title: "Quality Rating: Desconhecido",
          label: "N/A",
          description: "O quality rating ainda não foi determinado para esta conta."
        }
      },
      // Coexistência Status
      wabaCoexistence: {
        title: "Modo Coexistência",
        active: "Coexistência Ativa",
        migrated: "Migrado",
        activeDescription: "O WhatsApp Business App e a API estão funcionando simultaneamente neste número.",
        migratedDescription: "Este número foi migrado do Business App para a API.",
        offboarded: "Reconectando",
        offboardedDescription:
          "O número foi desconectado da API porque o cliente trocou de aparelho ou refez o registro no WhatsApp Business App. Os envios ficam pausados enquanto a Meta reconecta, o que normalmente leva alguns minutos. Se este aviso continuar por muito tempo, a reconexão não foi concluída e a conexão precisa ser verificada.",
        offboardedSince: "Desconectado desde {{since}}."
      },
      // Review Status
      wabaReview: {
        pending: "Pendente",
        inProgress: "Em Revisão",
        rejected: "Rejeitado",
        flagged: "Sinalizado",
        pending_description: "Sua conta está aguardando revisão da Meta.",
        review_in_progress_description: "A Meta está revisando sua conta. Isso pode levar até 72 horas.",
        rejected_description: "Sua conta foi rejeitada pela Meta. Verifique o console do desenvolvedor para mais detalhes.",
        flagged_description: "Sua conta foi sinalizada para revisão adicional."
      },
      // OAuth Callback - Página de redirecionamento do Meta
      oauthCallback: {
        // Títulos
        loadingTitle: "Processando...",
        successTitle: "Autorização Concluída!",
        errorTitle: "Erro na Autorização",
        cancelledTitle: "Autorização Cancelada",
        // Mensagens
        processing: "Aguarde enquanto processamos sua autorização...",
        success: "Autorização concluída com sucesso! Você pode retornar ao aplicativo.",
        successRedirect: "Autorização concluída! Clique no botão para continuar.",
        error: "Ocorreu um erro durante a autorização. Tente novamente.",
        cancelled: "Você cancelou o processo de autorização.",
        noCode: "Nenhum código de autorização recebido. Tente novamente.",
        storageError: "Erro ao salvar dados. Por favor, tente novamente.",
        // Ações
        closeWindow: "Fechar Janela",
        goToConnections: "Ir para Conexões",
        orRedirect: "ou",
        closingIn: "Esta janela será fechada em {{seconds}} segundos..."
      },
      calendarSelector: {
        all: "Todos",
        institutional: "Institucional",
        personal: "Pessoal",
        loading: "Carregando calendários...",
        error: "Erro ao carregar calendários",
        label: "Calendário",
        placeholder: "Selecione um calendário",
      },
      calendar: {
        slot: {
          ticketLabel: "Atendimento (opcional)",
          ticketNone: "Nenhum",
          ticketLoadError: "Não foi possível carregar os atendimentos",
          queueFromTicket: "A fila vem do atendimento",
          noQueue: "Sem fila",
          ticketOption: "#{{id}} · {{status}} · {{queue}} · {{date}}",
          statuses: {
            open: "Aberto",
            pending: "Pendente",
            closed: "Fechado",
            lgpd: "LGPD",
            chatbot: "Chatbot",
            group: "Grupo",
            nps: "Avaliação",
          },
        },
        reassign: {
          title: "Realocar Agendamento",
          targetUser: "Usuário destino",
          targetQueue: "Fila destino",
          selectQueue: "Selecione uma fila",
          reason: "Motivo (opcional)",
          reasonPlaceholder: "Ex: Transferência de equipe",
          submit: "Realocar",
          cancel: "Cancelar",
          processing: "Realocando...",
          success: "Agendamento realocado com sucesso!",
          selectUserAndQueue: "Selecione o usuário e a fila de destino",
        },
      },
      calendarManagement: {
        title: "Gerenciar Agendas",
        subtitle: "Agendas pessoais de atendentes e sub-agendas por fila",
        institutionalSection: "Agenda da Empresa",
        personalSection: "Agendas Pessoais",
        subCalendarSection: "Provisionar Sub-agenda",
        noInstitutional: "Nenhuma agenda institucional conectada.",
        noPersonal: "Nenhuma agenda pessoal conectada ainda.",
        connectPersonal: "Conectar agenda pessoal para:",
        disconnect: "Desconectar agenda",
        removeSubCalendar: "Remover sub-agenda",
        selectUser: "Atendente",
        selectQueue: "Fila / Especialidade",
        provision: "Criar Sub-agenda",
        close: "Fechar",
      },
      stalledTickets: {
        title: "Atendimentos parados",
        subtitle: "Clientes que mandaram a última mensagem e ainda não tiveram resposta",
        tabs: { open: "Em atendimento", pending: "Aguardando" },
        filters: {
          user: "Atendente",
          queue: "Fila",
          whatsapp: "Conexão",
          all: "Todos",
          minWait: "Esperando há mais de",
          userPending: "Aguardando não tem atendente",
        },
        settings: {
          title: "Faixas de alerta",
          warn: "Atenção a partir de (min)",
          danger: "Crítico a partir de (min)",
          invalid: "O limite de atenção precisa ser menor que o crítico",
          save: "Salvar",
        },
        level: { normal: "Dentro da faixa", warning: "Atenção", danger: "Crítico" },
        summary: { noQueue: "Sem fila", tickets: "parados", maxWait: "maior espera" },
        timeline: {
          titleOpen: "Quem está segurando a fila",
          titlePending: "Onde os clientes estão esperando",
          hint: "Cada ponto é um cliente esperando. Clique numa linha para filtrar.",
          legendOk: "até {{time}}",
          legendWarn: "{{from}} a {{to}}",
          legendDanger: "mais de {{time}}",
          maxWait: "maior espera",
          waitingFor: "Esperando há {{time}}",
          ariaLane: "{{name}}: {{count}} parados, maior espera {{time}}",
        },
        table: {
          contact: "Contato",
          user: "Atendente",
          queue: "Fila",
          whatsapp: "Conexão",
          waiting: "Esperando há",
          lastMessage: "Última mensagem do cliente",
          actions: "Ações",
          noUser: "Sem atendente",
          noWhatsapp: "Sem conexão",
          since: "Desde",
          openTicket: "Abrir ticket #{{id}} de {{name}}",
        },
        empty: "Nenhum cliente esperando resposta há mais de {{time}}",
        emptyFiltered: "Nenhum cliente neste filtro esperando resposta há mais de {{time}}",
        clearFilters: "Limpar filtros",
        truncated: "Mais de 2000 clientes parados nesta aba. Mostrando os que esperam há mais tempo; use os filtros para refinar.",
        error: "Não foi possível carregar os atendimentos parados",
        staleError: "Não foi possível atualizar. A lista abaixo pode estar desatualizada.",
        retry: "Tentar de novo",
        refresh: "Atualizar",
        loading: "Carregando atendimentos parados",
        updatedNow: "Atualizado agora",
        updatedAgo: "Atualizado há {{time}}",
        pageLabel: "Página {{page}}",
        openPending: {
          title: "Abrir ticket sem responsável",
          message: "Abrir marca as mensagens como lidas e o cliente recebe a confirmação de leitura. Continuar?",
          confirm: "Abrir",
        },
        actions: {
          menu: "Ações",
          menuFor: "Ações do ticket #{{id}} de {{name}}",
          preview: "Prévia",
          transfer: "Transferir",
          assume: "Assumir",
          assuming: "Assumindo...",
          nudge: "Cobrar atendente",
          assumeTitle: "Assumir atendimento",
          assumeMessage: "Você passa a ser o responsável pelo atendimento de {{name}}. Continuar?",
          assumeSuccess: "Ticket assumido",
          transferSuccess: "Ticket transferido",
          nudgeTitle: "Cobrar atendente",
          nudgeLabel: "Mensagem pelo chat interno",
          nudgeTo: "Para: {{name}} · espera {{time}}",
          nudgeSend: "Enviar",
          nudgeSending: "Enviando...",
          nudgeSuccess: "Lembrete enviado para {{name}}",
        },
        nudgeTemplate:
          "Olá, {{attendantName}}. O cliente {{contactName}} está aguardando resposta há {{waitingText}} no ticket #{{ticketId}}.",
        media: {
          image: "Imagem",
          video: "Vídeo",
          audio: "Áudio",
          document: "Documento",
          sticker: "Figurinha",
          location: "Localização",
          vcard: "Contato",
          file: "Arquivo",
        },
        prevPage: "Página anterior",
        nextPage: "Próxima página",
      },
      moments: {
        title: "Painel de Atendimentos em Tempo Real",
        empty: {
          title: "Nenhum ticket encontrado",
          subtitle: "Os tickets aparecerão aqui quando estiverem disponíveis",
          noResults: "Nenhum resultado para os filtros selecionados",
        },
        toolbar: {
          filters: "Filtros",
          groupByUser: "Agrupar por atendente",
          groupByQueue: "Agrupar por fila",
          compactMode: "Modo compacto",
          alerts: "Alertas sonoros",
          help: "Ajuda",
          refresh: "Atualizar dados",
          fullscreen: "Tela cheia",
          exitFullscreen: "Sair da tela cheia (ESC)",
          collapseOffline: "Colapsar offline",
        },
        filters: {
          search: "Buscar contato ou ticket...",
          clear: "Limpar filtros",
          queue: "Filtrar por fila",
          status: "Filtrar por status",
          connection: "Filtrar por conexão",
        },
        status: {
          online: "Online",
          paused: "Em Pausa",
          offline: "Offline",
          pending: "Pendentes",
        },
        column: {
          noTickets: "Nenhum ticket",
          avgResponseTime: "Tempo médio de resposta",
          avgFirstResponse: "Tempo médio de 1ª resposta",
          avgQueueTime: "Tempo médio em fila",
          urgentTooltip: "aguardando resposta há mais de 30 minutos",
          capacity: "Capacidade",
          collapse: "Colapsar",
          expand: "Expandir",
        },
        ticket: {
          view: "Visualizar ticket",
          queue: "Fila",
          noQueue: "SEM FILA",
          connection: "Conexão",
          noConnection: "SEM CONEXÃO",
          waitingSince: "Aguardando resposta há",
        },
        contextMenu: {
          open: "Abrir ticket",
          transfer: "Transferir ticket",
          assume: "Assumir ticket",
          close: "Finalizar ticket",
        },
        actions: {
          transferSuccess: "Ticket transferido com sucesso",
          assumeSuccess: "Ticket assumido com sucesso",
          closeSuccess: "Ticket finalizado com sucesso",
        },
        confirmClose: {
          title: "Finalizar ticket",
          message: "Tem certeza que deseja finalizar este ticket? Esta ação não pode ser desfeita.",
          cancel: "Cancelar",
          confirm: "Finalizar",
        },
        preview: {
          title: "Últimas mensagens",
          empty: "Nenhuma mensagem encontrada",
          openFull: "Abrir conversa completa",
        },
        alerts: {
          title: "Configurar Alertas Sonoros",
          enable: "Ativar alertas sonoros",
          waitThreshold: "Alertar quando ticket aguardar",
          pendingThreshold: "Alertar quando pendentes atingirem",
          close: "Fechar",
        },
        help: {
          title: "Ajuda - Painel de Atendimentos",
          statusColors: "Cores do Cabeçalho",
          green: "Verde",
          greenDesc: "Atendente online e disponível",
          yellow: "Amarelo",
          yellowDesc: "Atendente em pausa (horário de almoço/intervalo)",
          red: "Vermelho",
          redDesc: "Atendente offline (não logado)",
          gray: "Cinza",
          grayDesc: "Tickets pendentes (sem atendente atribuído)",
          interactionTitle: "Interação com Tickets",
          dragDrop: "Arraste tickets entre colunas para transferir (apenas supervisores/admins)",
          rightClick: "Clique com botão direito no ticket para ações rápidas (transferir, assumir, finalizar)",
          hoverPreview: "Passe o mouse sobre um ticket para pré-visualizar as últimas mensagens",
          toolbarTitle: "Barra de Ferramentas",
          filterDesc: "Use os filtros para buscar por nome/ID, filtrar por status do atendente (online, pausa, offline) ou por fila",
          groupByDesc: "Alterne entre agrupar por atendente (visão individual) ou por fila/setor (visão departamental)",
          compactDesc: "Ative o modo compacto para ver mais tickets por coluna — exibe apenas nome, tempo e badges em uma linha",
          collapseDesc: "Clique na seta no cabeçalho da coluna para colapsá-la. Clique novamente para expandir. O estado é salvo automaticamente",
          metricsTitle: "Métricas e Indicadores",
          capacityDesc: "A barra colorida no cabeçalho indica a capacidade: verde (leve), amarelo (moderado), vermelho (sobrecarregado)",
          timerDesc: "Tickets aguardando resposta exibem um timer ao vivo com borda vermelha. Acima de 30 min, o card pulsa",
          urgentBadge: "O badge vermelho com número indica tickets urgentes aguardando há mais de 30 minutos",
          alertsTitle: "Alertas Sonoros",
          alertsDesc: "Configure alertas para ser notificado quando tickets aguardam muito tempo ou quando há muitos pendentes na fila",
          fullscreenDesc: "Use o modo tela cheia para uma visão expandida. Pressione ESC para sair",
        },
      },
      ifood: {
        connectionModal: {
          defaultQueue: "Fila dos pedidos",
          defaultQueueHelp:
            "Pedidos novos entram nesta fila. Sem fila, só quem tem 'Visualizar chamados sem fila' os vê.",
        },
      },
    }
  }
};

export { messages };
